// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Js_dict = require("rescript/lib/js/js_dict.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_Result = require("rescript/lib/js/belt_Result.js");
var Util$SmartcutsMacros = require("../../bs-utils/src/Util.bs.js");
var Image$SmartcutsMacros = require("./Image.bs.js");
var Command$SmartcutsMacros = require("./Command.bs.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var StringUtils$SmartcutsMacros = require("../../bs-utils/src/StringUtils.bs.js");
var RenderOnHost$SmartcutsMacros = require("./RenderOnHost.bs.js");
var UrlConstraint$SmartcutsMacros = require("./UrlConstraint.bs.js");
var CommandContext$SmartcutsMacros = require("./CommandContext.bs.js");
var PlaybackOptions$SmartcutsMacros = require("./PlaybackOptions.bs.js");
var Browser__Runtime$SmartcutsMacros = require("./browser/Browser__Runtime.bs.js");
var DOM__HtmlElement$SmartcutsMacros = require("./DOM__HtmlElement.bs.js");
var InnerTextSemantic$SmartcutsMacros = require("./semantics/InnerTextSemantic.bs.js");
var SelectorOverrides$SmartcutsMacros = require("./commands/shared/SelectorOverrides.bs.js");
var SelectionSemantics$SmartcutsMacros = require("./SelectionSemantics/SelectionSemantics.bs.js");
var JsPromiseErrorUtils$SmartcutsMacros = require("../../bs-utils/src/JsPromiseErrorUtils.bs.js");
var CommandPreconditions$SmartcutsMacros = require("./CommandPreconditions.bs.js");
var CommandPlaybackRuntime$SmartcutsMacros = require("./CommandPlaybackRuntime.bs.js");
var RenderOnHost__Geometry$SmartcutsMacros = require("./RenderOnHost__Geometry.bs.js");
var HighlightElement__Shared$SmartcutsMacros = require("./HighlightElement__Shared.bs.js");
var MultiUrlTriggering__Types$SmartcutsMacros = require("./app/MultiUrlTriggering/MultiUrlTriggering__Types.bs.js");
var DataExtraction__DataRecord$SmartcutsMacros = require("../../bs-data-extraction/src/DataExtraction__DataRecord.bs.js");
var ExtErrors__OverlayBlocking$SmartcutsMacros = require("./ExtErrors__OverlayBlocking.bs.js");
var ExtensionMessagingBuilders$SmartcutsMacros = require("./ExtensionMessagingBuilders.bs.js");
var MultiUrlTriggering__Shared$SmartcutsMacros = require("./app/MultiUrlTriggering/MultiUrlTriggering__Shared.bs.js");
var MultiUrlTriggering__LinkGroup$SmartcutsMacros = require("./app/MultiUrlTriggering/MultiUrlTriggering__LinkGroup.bs.js");
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = require("./InterfaceBtwnContentScriptAndBg.bs.js");

function message_encode(v) {
  return ["StartStreamingEventsToBackground"];
}

function message_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "StartStreamingEventsToBackground") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* StartStreamingEventsToBackground */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode(v) {
  return ["TabDidSetupEventStreaming"];
}

function response_decode(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "TabDidSetupEventStreaming") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* TabDidSetupEventStreaming */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_StartStreamingEventsToBackground = {
  message_encode: message_encode,
  message_decode: message_decode,
  response_encode: response_encode,
  response_decode: response_decode
};

function message_encode$1(v) {
  return ["StopStreamingEventsToBackground"];
}

function message_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "StopStreamingEventsToBackground") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* StopStreamingEventsToBackground */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$1(v) {
  return ["TabDidStopStreamingEventsToBackground"];
}

function response_decode$1(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "TabDidStopStreamingEventsToBackground") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* TabDidStopStreamingEventsToBackground */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_StopStreamingEventsToBackground = {
  message_encode: message_encode$1,
  message_decode: message_decode$1,
  response_encode: response_encode$1,
  response_decode: response_decode$1
};

function message_encode$2(v) {
  return [
          "Playback",
          Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_encode, v._0),
          PlaybackOptions$SmartcutsMacros.t_encode(v._1),
          Decco.optionToJson(CommandPreconditions$SmartcutsMacros.t_encode, v._2)
        ];
}

function message_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "Playback") {
    if (tagged.length !== 4) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var match$1 = Curry._1(CommandPlaybackRuntime$SmartcutsMacros.CommandType.t_decode, Belt_Array.getExn(jsonArr$1, 1));
    var match$2 = PlaybackOptions$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 2));
    var match$3 = Decco.optionFromJson(CommandPreconditions$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 3));
    if (match$1.TAG === /* Ok */0) {
      if (match$2.TAG === /* Ok */0) {
        if (match$3.TAG === /* Ok */0) {
          return {
                  TAG: /* Ok */0,
                  _0: /* Playback */{
                    _0: match$1._0,
                    _1: match$2._0,
                    _2: match$3._0
                  }
                };
        }
        var e = match$3._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: "[2]" + e.path,
                  message: e.message,
                  value: e.value
                }
              };
      }
      var e$1 = match$2._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[1]" + e$1.path,
                message: e$1.message,
                value: e$1.value
              }
            };
    }
    var e$2 = match$1._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e$2.path,
              message: e$2.message,
              value: e$2.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function tabDidCollectDataGroups_encode(v) {
  return Js_dict.fromArray([[
                "dataRecordsWithDataNodeId",
                Decco.arrayToJson((function (param) {
                        return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_encode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_encode, Decco.stringToJson, param);
                      }), v.dataRecordsWithDataNodeId)
              ]]);
}

function tabDidCollectDataGroups_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dataRecordsWithDataNodeId = Decco.arrayFromJson((function (param) {
          return DataExtraction__DataRecord$SmartcutsMacros.WithHtmlElementAndHTPIAndTagPathAndDataNodeId.t_decode(InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ElementRef.t_decode, Decco.stringFromJson, param);
        }), Belt_Option.getWithDefault(Js_dict.get(dict._0, "dataRecordsWithDataNodeId"), null));
  if (dataRecordsWithDataNodeId.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              dataRecordsWithDataNodeId: dataRecordsWithDataNodeId._0
            }
          };
  }
  var e = dataRecordsWithDataNodeId._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".dataRecordsWithDataNodeId" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function response_encode$2(v) {
  if (typeof v === "number") {
    return ["TabDidPlaybackCommand"];
  }
  switch (v.TAG | 0) {
    case /* TabDidClickLink */0 :
        return [
                "TabDidClickLink",
                Decco.stringToJson(v._0)
              ];
    case /* TabDidCopyText */1 :
        return [
                "TabDidCopyText",
                Decco.stringToJson(v._0)
              ];
    case /* TabDidTakeScreenshot */2 :
        return [
                "TabDidTakeScreenshot",
                Decco.stringToJson(v._0),
                Image$SmartcutsMacros.Metadata.t_encode(v._1)
              ];
    case /* TabDidCollectDataGroups */3 :
        return [
                "TabDidCollectDataGroups",
                tabDidCollectDataGroups_encode(v._0)
              ];
    case /* TabCouldNotFindElement */4 :
        return [
                "TabCouldNotFindElement",
                Decco.stringToJson(v._0),
                SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_encode(v._1)
              ];
    case /* TabOrWindowNotVisible */5 :
        return [
                "TabOrWindowNotVisible",
                Decco.stringToJson(v._0)
              ];
    case /* TabOrWindowVisibilityUnknownOrUnloaded */6 :
        return [
                "TabOrWindowVisibilityUnknownOrUnloaded",
                Decco.stringToJson(v._0)
              ];
    case /* TabCouldNotApplySemantic */7 :
        return [
                "TabCouldNotApplySemantic",
                SelectionSemantics$SmartcutsMacros.findInDomAndApplySemanticError_encode(v._0),
                Decco.stringToJson(v._1)
              ];
    case /* TabCannotCopyMissingSrcOfImg */8 :
        return [
                "TabCannotCopyMissingSrcOfImg",
                Decco.stringToJson(v._0),
                SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_encode(v._1)
              ];
    case /* TabCouldNotPlaybackBecauseOverlayBlockingTargetElement */9 :
        return [
                "TabCouldNotPlaybackBecauseOverlayBlockingTargetElement",
                ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_encode(Decco.stringToJson, v._0),
                Decco.stringToJson(v._1)
              ];
    case /* ErrorWhileWaitForOverlayToStopBlockingElement */10 :
        return [
                "ErrorWhileWaitForOverlayToStopBlockingElement",
                Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                Decco.stringToJson(v._1)
              ];
    case /* ErrorWhileSearchForElement */11 :
        return [
                "ErrorWhileSearchForElement",
                Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_encode, v._0),
                Decco.stringToJson(v._1)
              ];
    case /* TabDidEvaluateSwitchCommand */12 :
        return [
                "TabDidEvaluateSwitchCommand",
                CommandPlaybackRuntime$SmartcutsMacros.tabDidEvaluateSwitchCommand_encode(v._0)
              ];
    case /* UnimplementedInTab */13 :
        return [
                "UnimplementedInTab",
                Decco.stringToJson(v._0)
              ];
    
  }
}

function response_decode$2(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ErrorWhileSearchForElement" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$1 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$1.TAG === /* Ok */0) {
            if (match$2.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ErrorWhileSearchForElement */11,
                        _0: match$1._0,
                        _1: match$2._0
                      }
                    };
            }
            var e = match$2._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "ErrorWhileWaitForOverlayToStopBlockingElement" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$3 = Curry._1(JsPromiseErrorUtils$SmartcutsMacros.JsPromiseError.t_decode, Belt_Array.getExn(jsonArr$1, 1));
          var match$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$3.TAG === /* Ok */0) {
            if (match$4.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* ErrorWhileWaitForOverlayToStopBlockingElement */10,
                        _0: match$3._0,
                        _1: match$4._0
                      }
                    };
            }
            var e$2 = match$4._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = match$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "TabCannotCopyMissingSrcOfImg" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$6 = SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$5.TAG === /* Ok */0) {
            if (match$6.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* TabCannotCopyMissingSrcOfImg */8,
                        _0: match$5._0,
                        _1: match$6._0
                      }
                    };
            }
            var e$4 = match$6._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$4.path,
                      message: e$4.message,
                      value: e$4.value
                    }
                  };
          }
          var e$5 = match$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "TabCouldNotApplySemantic" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$7 = SelectionSemantics$SmartcutsMacros.findInDomAndApplySemanticError_decode(Belt_Array.getExn(jsonArr$1, 1));
          var match$8 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$7.TAG === /* Ok */0) {
            if (match$8.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* TabCouldNotApplySemantic */7,
                        _0: match$7._0,
                        _1: match$8._0
                      }
                    };
            }
            var e$6 = match$8._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$6.path,
                      message: e$6.message,
                      value: e$6.value
                    }
                  };
          }
          var e$7 = match$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "TabCouldNotFindElement" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$9 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$10 = SelectorOverrides$SmartcutsMacros.elementLocatorInTermsOfStrategy_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$9.TAG === /* Ok */0) {
            if (match$10.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* TabCouldNotFindElement */4,
                        _0: match$9._0,
                        _1: match$10._0
                      }
                    };
            }
            var e$8 = match$10._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$8.path,
                      message: e$8.message,
                      value: e$8.value
                    }
                  };
          }
          var e$9 = match$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "TabCouldNotPlaybackBecauseOverlayBlockingTargetElement" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$11 = ExtErrors__OverlayBlocking$SmartcutsMacros.overlayStillBlockingElementAfterMs_decode(Decco.stringFromJson, Belt_Array.getExn(jsonArr$1, 1));
          var match$12 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 2));
          if (match$11.TAG === /* Ok */0) {
            if (match$12.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* TabCouldNotPlaybackBecauseOverlayBlockingTargetElement */9,
                        _0: match$11._0,
                        _1: match$12._0
                      }
                    };
            }
            var e$10 = match$12._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$10.path,
                      message: e$10.message,
                      value: e$10.value
                    }
                  };
          }
          var e$11 = match$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "TabDidClickLink" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TabDidClickLink */0,
                      _0: v0._0
                    }
                  };
          }
          var e$12 = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "TabDidCollectDataGroups" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = tabDidCollectDataGroups_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TabDidCollectDataGroups */3,
                      _0: v0$1._0
                    }
                  };
          }
          var e$13 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "TabDidCopyText" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TabDidCopyText */1,
                      _0: v0$2._0
                    }
                  };
          }
          var e$14 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      case "TabDidEvaluateSwitchCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = CommandPlaybackRuntime$SmartcutsMacros.tabDidEvaluateSwitchCommand_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TabDidEvaluateSwitchCommand */12,
                      _0: v0$3._0
                    }
                  };
          }
          var e$15 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
      case "TabDidPlaybackCommand" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* TabDidPlaybackCommand */0
                  };
          }
      case "TabDidTakeScreenshot" :
          if (tagged.length !== 3) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var match$13 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          var match$14 = Image$SmartcutsMacros.Metadata.t_decode(Belt_Array.getExn(jsonArr$1, 2));
          if (match$13.TAG === /* Ok */0) {
            if (match$14.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: {
                        TAG: /* TabDidTakeScreenshot */2,
                        _0: match$13._0,
                        _1: match$14._0
                      }
                    };
            }
            var e$16 = match$14._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e$16.path,
                      message: e$16.message,
                      value: e$16.value
                    }
                  };
          }
          var e$17 = match$13._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "TabOrWindowNotVisible" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TabOrWindowNotVisible */5,
                      _0: v0$4._0
                    }
                  };
          }
          var e$18 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                  }
                };
      case "TabOrWindowVisibilityUnknownOrUnloaded" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* TabOrWindowVisibilityUnknownOrUnloaded */6,
                      _0: v0$5._0
                    }
                  };
          }
          var e$19 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$19.path,
                    message: e$19.message,
                    value: e$19.value
                  }
                };
      case "UnimplementedInTab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* UnimplementedInTab */13,
                      _0: v0$6._0
                    }
                  };
          }
          var e$20 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_Playback = {
  message_encode: message_encode$2,
  message_decode: message_decode$2,
  response_encode: response_encode$2,
  response_decode: response_decode$2,
  tabDidCollectDataGroups_encode: tabDidCollectDataGroups_encode,
  tabDidCollectDataGroups_decode: tabDidCollectDataGroups_decode
};

function message_encode$3(v) {
  return ["PlaybackExited"];
}

function message_decode$3(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "PlaybackExited") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* PlaybackExited */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$3(v) {
  return ["AckPlaybackExited"];
}

function response_decode$3(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckPlaybackExited") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckPlaybackExited */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_PlaybackExited = {
  message_encode: message_encode$3,
  message_decode: message_decode$3,
  response_encode: response_encode$3,
  response_decode: response_decode$3
};

function message_encode$4(v) {
  if (v) {
    return [
            "RenderInContentScript",
            RenderOnHost$SmartcutsMacros.t_encode(v._0)
          ];
  } else {
    return ["RemoveRenderedContent"];
  }
}

function message_decode$4(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "RemoveRenderedContent" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RemoveRenderedContent */0
                  };
          }
      case "RenderInContentScript" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = RenderOnHost$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* RenderInContentScript */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$4(v) {
  return ["AckRenderInContentScript"];
}

function response_decode$4(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckRenderInContentScript") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckRenderInContentScript */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_RenderInContentScript = {
  message_encode: message_encode$4,
  message_decode: message_decode$4,
  response_encode: response_encode$4,
  response_decode: response_decode$4
};

function message_encode$5(v) {
  return [
          "AskContentScriptToAdjustModalGeometry",
          RenderOnHost__Geometry$SmartcutsMacros.t_encode(v._0)
        ];
}

function message_decode$5(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskContentScriptToAdjustModalGeometry") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = RenderOnHost__Geometry$SmartcutsMacros.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskContentScriptToAdjustModalGeometry */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$5(v) {
  if (v) {
    return ["ContentScriptDidNotAdjustModalGeometry"];
  } else {
    return ["ContentScriptDidAdjustModalGeometry"];
  }
}

function response_decode$5(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ContentScriptDidAdjustModalGeometry" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ContentScriptDidAdjustModalGeometry */0
                  };
          }
      case "ContentScriptDidNotAdjustModalGeometry" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ContentScriptDidNotAdjustModalGeometry */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskContentScriptToAdjustModalGeometry = {
  message_encode: message_encode$5,
  message_decode: message_decode$5,
  response_encode: response_encode$5,
  response_decode: response_decode$5
};

function params_encode(v) {
  return Js_dict.fromArray([
              [
                "maybeTriggeringLinkUrlAndText",
                Decco.optionToJson((function (param) {
                        return [
                                Decco.stringToJson(param[0]),
                                Decco.optionToJson(Decco.stringToJson, param[1])
                              ];
                      }), v.maybeTriggeringLinkUrlAndText)
              ],
              [
                "isPlaybackMode",
                Decco.boolToJson(v.isPlaybackMode)
              ]
            ]);
}

function params_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var maybeTriggeringLinkUrlAndText = Decco.optionFromJson((function (json) {
          var match = Js_json.classify(json);
          if (typeof match === "number") {
            return Decco.error(undefined, "Not a tuple", json);
          }
          if (match.TAG !== /* JSONArray */3) {
            return Decco.error(undefined, "Not a tuple", json);
          }
          var match$1 = match._0;
          if (match$1.length !== 2) {
            return Decco.error(undefined, "Incorrect cardinality", json);
          }
          var v0 = match$1[0];
          var v1 = match$1[1];
          var match$2 = Decco.stringFromJson(v0);
          var match$3 = Decco.optionFromJson(Decco.stringFromJson, v1);
          if (match$2.TAG === /* Ok */0) {
            if (match$3.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: [
                        match$2._0,
                        match$3._0
                      ]
                    };
            }
            var e = match$3._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[1]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "maybeTriggeringLinkUrlAndText"), null));
  if (maybeTriggeringLinkUrlAndText.TAG === /* Ok */0) {
    var isPlaybackMode = Decco.boolFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "isPlaybackMode"), null));
    if (isPlaybackMode.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                maybeTriggeringLinkUrlAndText: maybeTriggeringLinkUrlAndText._0,
                isPlaybackMode: isPlaybackMode._0
              }
            };
    }
    var e = isPlaybackMode._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".isPlaybackMode" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = maybeTriggeringLinkUrlAndText._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".maybeTriggeringLinkUrlAndText" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function message_encode$6(v) {
  return [
          "AskContentScriptToEnterUrlTriggeringMode",
          params_encode(v._0)
        ];
}

function message_decode$6(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskContentScriptToEnterUrlTriggeringMode") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = params_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskContentScriptToEnterUrlTriggeringMode */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$6(v) {
  if (v) {
    return ["RequiresUserToTryAgain"];
  } else {
    return ["ContentScriptDidEnterUrlTriggeringMode"];
  }
}

function response_decode$6(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "ContentScriptDidEnterUrlTriggeringMode" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* ContentScriptDidEnterUrlTriggeringMode */0
                  };
          }
      case "RequiresUserToTryAgain" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* RequiresUserToTryAgain */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskContentScriptToEnterUrlTriggeringMode = {
  message_encode: message_encode$6,
  message_decode: message_decode$6,
  params_encode: params_encode,
  params_decode: params_decode,
  response_encode: response_encode$6,
  response_decode: response_decode$6
};

function message_encode$7(v) {
  return [
          "RefreshLinks",
          Decco.arrayToJson((function (param) {
                  return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, param);
                }), v._0),
          MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_encode(v._1),
          Decco.arrayToJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_encode, v._2),
          MultiUrlTriggering__Shared$SmartcutsMacros.Step.t_encode(v._3),
          Decco.optionToJson(MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.t_encode, v._4)
        ];
}

function message_decode$7(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "RefreshLinks") {
    if (tagged.length !== 6) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var match$1 = Decco.arrayFromJson((function (param) {
            return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, param);
          }), Belt_Array.getExn(jsonArr$1, 1));
    var match$2 = MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_decode(Belt_Array.getExn(jsonArr$1, 2));
    var match$3 = Decco.arrayFromJson(UrlConstraint$SmartcutsMacros.UrlPattern.t_decode, Belt_Array.getExn(jsonArr$1, 3));
    var match$4 = MultiUrlTriggering__Shared$SmartcutsMacros.Step.t_decode(Belt_Array.getExn(jsonArr$1, 4));
    var match$5 = Decco.optionFromJson(MultiUrlTriggering__Types$SmartcutsMacros.PaginateFn.t_decode, Belt_Array.getExn(jsonArr$1, 5));
    if (match$1.TAG === /* Ok */0) {
      if (match$2.TAG === /* Ok */0) {
        if (match$3.TAG === /* Ok */0) {
          if (match$4.TAG === /* Ok */0) {
            if (match$5.TAG === /* Ok */0) {
              return {
                      TAG: /* Ok */0,
                      _0: /* RefreshLinks */{
                        _0: match$1._0,
                        _1: match$2._0,
                        _2: match$3._0,
                        _3: match$4._0,
                        _4: match$5._0
                      }
                    };
            }
            var e = match$5._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: "[4]" + e.path,
                      message: e.message,
                      value: e.value
                    }
                  };
          }
          var e$1 = match$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[3]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
        }
        var e$2 = match$3._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: "[2]" + e$2.path,
                  message: e$2.message,
                  value: e$2.value
                }
              };
      }
      var e$3 = match$2._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[1]" + e$3.path,
                message: e$3.message,
                value: e$3.value
              }
            };
    }
    var e$4 = match$1._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e$4.path,
              message: e$4.message,
              value: e$4.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$7(v) {
  if (v) {
    return [
            "LinksUpdated",
            Decco.arrayToJson((function (param) {
                    return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, param);
                  }), v._0)
          ];
  } else {
    return ["NoUpdate"];
  }
}

function response_decode$7(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "LinksUpdated" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = Decco.arrayFromJson((function (param) {
                  return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, param);
                }), Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: /* LinksUpdated */{
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "NoUpdate" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* NoUpdate */0
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_RefreshLinks = {
  message_encode: message_encode$7,
  message_decode: message_decode$7,
  response_encode: response_encode$7,
  response_decode: response_decode$7
};

function message_encode$8(v) {
  return [
          "UpdateLinks",
          Decco.arrayToJson((function (param) {
                  return MultiUrlTriggering__Shared$SmartcutsMacros.link_encode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__encode, param);
                }), v._0)
        ];
}

function message_decode$8(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "UpdateLinks") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.arrayFromJson((function (param) {
            return MultiUrlTriggering__Shared$SmartcutsMacros.link_decode(DOM__HtmlElement$SmartcutsMacros.ForSerialization.t__decode, param);
          }), Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* UpdateLinks */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$8(v) {
  return ["AckLinksUpdated"];
}

function response_decode$8(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckLinksUpdated") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckLinksUpdated */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_UpdateLinks = {
  message_encode: message_encode$8,
  message_decode: message_decode$8,
  response_encode: response_encode$8,
  response_decode: response_decode$8
};

function message_encode$9(v) {
  return [
          "TellTabToUpdateLinkGroups",
          MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_encode(v._0)
        ];
}

function message_decode$9(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "TellTabToUpdateLinkGroups") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = MultiUrlTriggering__Shared$SmartcutsMacros.LinkGroups.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* TellTabToUpdateLinkGroups */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$9(v) {
  return ["AckUpdateLinkGroups"];
}

function response_decode$9(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckUpdateLinkGroups") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckUpdateLinkGroups */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_TellTabToUpdateLinkGroups = {
  message_encode: message_encode$9,
  message_decode: message_decode$9,
  response_encode: response_encode$9,
  response_decode: response_decode$9
};

function message_encode$10(v) {
  return ["Exit"];
}

function message_decode$10(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "Exit") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* Exit */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$10(v) {
  return ["AckExit"];
}

function response_decode$10(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckExit") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckExit */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_Exit = {
  message_encode: message_encode$10,
  message_decode: message_decode$10,
  response_encode: response_encode$10,
  response_decode: response_decode$10
};

function message_encode$11(v) {
  return [
          "AskContentScriptToRecordPageAction",
          MultiUrlTriggering__Shared$SmartcutsMacros.pageAction_encode(v._0)
        ];
}

function message_decode$11(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskContentScriptToRecordPageAction") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = MultiUrlTriggering__Shared$SmartcutsMacros.pageAction_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskContentScriptToRecordPageAction */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$11(v) {
  return ["ContentScriptDidRecordPageAction"];
}

function response_decode$11(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ContentScriptDidRecordPageAction") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* ContentScriptDidRecordPageAction */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_AskContentScriptToRecordPageAction = {
  message_encode: message_encode$11,
  message_decode: message_decode$11,
  response_encode: response_encode$11,
  response_decode: response_decode$11
};

function message_encode$12(v) {
  return ["StopRecordPageAction"];
}

function message_decode$12(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "StopRecordPageAction") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* StopRecordPageAction */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$12(v) {
  return ["AckStopRecordPageAction"];
}

function response_decode$12(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckStopRecordPageAction") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckStopRecordPageAction */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_StopRecordPageAction = {
  message_encode: message_encode$12,
  message_decode: message_decode$12,
  response_encode: response_encode$12,
  response_decode: response_decode$12
};

function message_encode$13(v) {
  return [
          "PlaybackPageActionUntil",
          MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_encode(v._0)
        ];
}

function message_decode$13(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "PlaybackPageActionUntil") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = MultiUrlTriggering__Types$SmartcutsMacros.pageUntil_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* PlaybackPageActionUntil */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$13(v) {
  return ["AckPlaybackPageAction"];
}

function response_decode$13(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckPlaybackPageAction") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckPlaybackPageAction */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_PlaybackPageAction = {
  message_encode: message_encode$13,
  message_decode: message_decode$13,
  response_encode: response_encode$13,
  response_decode: response_decode$13
};

function message_encode$14(v) {
  return ["DidFinishPlaybackPageAction"];
}

function message_decode$14(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidFinishPlaybackPageAction") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* DidFinishPlaybackPageAction */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$14(v) {
  return ["AckDidFinishPlaybackPageAction"];
}

function response_decode$14(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckDidFinishPlaybackPageAction") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckDidFinishPlaybackPageAction */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_DidFinishPlaybackPageAction = {
  message_encode: message_encode$14,
  message_decode: message_decode$14,
  response_encode: response_encode$14,
  response_decode: response_decode$14
};

function message_encode$15(v) {
  return [
          "ShowLinkWithId",
          Decco.stringToJson(v._0)
        ];
}

function message_decode$15(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "ShowLinkWithId") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = Decco.stringFromJson(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* ShowLinkWithId */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$15(v) {
  return ["AckShowLinkWithId"];
}

function response_decode$15(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckShowLinkWithId") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckShowLinkWithId */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_ShowLinkWithId = {
  message_encode: message_encode$15,
  message_decode: message_decode$15,
  response_encode: response_encode$15,
  response_decode: response_decode$15
};

function message_encode$16(v) {
  return ["SendContextLocalAndLinkGroups"];
}

function message_decode$16(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "SendContextLocalAndLinkGroups") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* SendContextLocalAndLinkGroups */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$16(v) {
  return [
          "GotContextLocalAndLinkGroups",
          CommandContext$SmartcutsMacros.commandContextLocal_encode(v._0),
          Decco.arrayToJson(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_encode, v._1)
        ];
}

function response_decode$16(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "GotContextLocalAndLinkGroups") {
    if (tagged.length !== 3) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var match$1 = CommandContext$SmartcutsMacros.commandContextLocal_decode(Belt_Array.getExn(jsonArr$1, 1));
    var match$2 = Decco.arrayFromJson(MultiUrlTriggering__LinkGroup$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
    if (match$1.TAG === /* Ok */0) {
      if (match$2.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: /* GotContextLocalAndLinkGroups */{
                  _0: match$1._0,
                  _1: match$2._0
                }
              };
      }
      var e = match$2._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = match$1._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_SendContextLocalAndLinkGroups = {
  message_encode: message_encode$16,
  message_decode: message_decode$16,
  response_encode: response_encode$16,
  response_decode: response_decode$16
};

function message_encode$17(v) {
  return ["PrepareForScreenshot"];
}

function message_decode$17(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "PrepareForScreenshot") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* PrepareForScreenshot */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$17(v) {
  return ["AckPrepareForScreenshot"];
}

function response_decode$17(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckPrepareForScreenshot") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckPrepareForScreenshot */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_UrlTriggering_PrepareForScreenshot = {
  message_encode: message_encode$17,
  message_decode: message_decode$17,
  response_encode: response_encode$17,
  response_decode: response_decode$17
};

function message_encode$18(v) {
  return ["Ping"];
}

function message_decode$18(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "Ping") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* Ping */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$18(v) {
  return ["Ack"];
}

function response_decode$18(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "Ack") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* Ack */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_PingTab = {
  message_encode: message_encode$18,
  message_decode: message_decode$18,
  response_encode: response_encode$18,
  response_decode: response_decode$18
};

function message_encode$19(v) {
  return [
          "DoesElementExistOnPage",
          Selector$SmartcutsMacros.elementSelector_encode(v._0),
          Decco.optionToJson(InnerTextSemantic$SmartcutsMacros.t_encode, v._1)
        ];
}

function message_decode$19(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DoesElementExistOnPage") {
    if (tagged.length !== 3) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var match$1 = Selector$SmartcutsMacros.elementSelector_decode(Belt_Array.getExn(jsonArr$1, 1));
    var match$2 = Decco.optionFromJson(InnerTextSemantic$SmartcutsMacros.t_decode, Belt_Array.getExn(jsonArr$1, 2));
    if (match$1.TAG === /* Ok */0) {
      if (match$2.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: /* DoesElementExistOnPage */{
                  _0: match$1._0,
                  _1: match$2._0
                }
              };
      }
      var e = match$2._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: "[1]" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = match$1._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$19(v) {
  if (v) {
    return ["DidNotFindElement"];
  } else {
    return ["DidFindElement"];
  }
}

function response_decode$19(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "DidFindElement" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidFindElement */0
                  };
          }
      case "DidNotFindElement" :
          if (tagged.length !== 1) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          } else {
            return {
                    TAG: /* Ok */0,
                    _0: /* DidNotFindElement */1
                  };
          }
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_DoesElementExistOnPage = {
  message_encode: message_encode$19,
  message_decode: message_decode$19,
  response_encode: response_encode$19,
  response_decode: response_decode$19
};

function message_encode$20(v) {
  return ["AskTabToRenderModalToExplainHighlightElement"];
}

function message_decode$20(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskTabToRenderModalToExplainHighlightElement") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AskTabToRenderModalToExplainHighlightElement */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$20(v) {
  return ["AckRenderModalToExplainHighlightElement"];
}

function response_decode$20(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AckRenderModalToExplainHighlightElement") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AckRenderModalToExplainHighlightElement */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskTabToRenderModalToExplainHighlightElement = {
  message_encode: message_encode$20,
  message_decode: message_decode$20,
  response_encode: response_encode$20,
  response_decode: response_decode$20
};

function message_encode$21(v) {
  return [
          "AskTabToSetupHighlightElementControl",
          HighlightElement__Shared$SmartcutsMacros.Callback.t_encode(v._0)
        ];
}

function message_decode$21(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskTabToSetupHighlightElementControl") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = HighlightElement__Shared$SmartcutsMacros.Callback.t_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* AskTabToSetupHighlightElementControl */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$21(v) {
  return ["DidSetupHighlightElementControl"];
}

function response_decode$21(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidSetupHighlightElementControl") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* DidSetupHighlightElementControl */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskTabToSetupHighlightElementControl = {
  message_encode: message_encode$21,
  message_decode: message_decode$21,
  response_encode: response_encode$21,
  response_decode: response_decode$21
};

function message_encode$22(v) {
  return ["AskTabToTeardownHighlightElementControl"];
}

function message_decode$22(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskTabToTeardownHighlightElementControl") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AskTabToTeardownHighlightElementControl */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$22(v) {
  return ["DidTeardownHighlightElementControl"];
}

function response_decode$22(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidTeardownHighlightElementControl") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* DidTeardownHighlightElementControl */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskTabToTeardownHighlightElementControl = {
  message_encode: message_encode$22,
  message_decode: message_decode$22,
  response_encode: response_encode$22,
  response_decode: response_decode$22
};

function message_encode$23(v) {
  return ["AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand"];
}

function message_decode$23(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$23(v) {
  return ["DidHideSmartcutsPlaybackModalUntilCompletedCommand"];
}

function response_decode$23(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "DidHideSmartcutsPlaybackModalUntilCompletedCommand") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* DidHideSmartcutsPlaybackModalUntilCompletedCommand */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = {
  message_encode: message_encode$23,
  message_decode: message_decode$23,
  response_encode: response_encode$23,
  response_decode: response_decode$23
};

function message_encode$24(v) {
  return ["AskTabToEnterDataExtractionMode"];
}

function message_decode$24(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskTabToEnterDataExtractionMode") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AskTabToEnterDataExtractionMode */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function tabDidEnterDataExtractionMode_encode(v) {
  return Js_dict.fromArray([[
                "newWindowCommandWithContextLocal",
                Command$SmartcutsMacros.CommandWithContextLocal.t_encode(v.newWindowCommandWithContextLocal)
              ]]);
}

function tabDidEnterDataExtractionMode_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var newWindowCommandWithContextLocal = Command$SmartcutsMacros.CommandWithContextLocal.t_decode(Belt_Option.getWithDefault(Js_dict.get(dict._0, "newWindowCommandWithContextLocal"), null));
  if (newWindowCommandWithContextLocal.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              newWindowCommandWithContextLocal: newWindowCommandWithContextLocal._0
            }
          };
  }
  var e = newWindowCommandWithContextLocal._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".newWindowCommandWithContextLocal" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function response_encode$24(v) {
  return [
          "TabDidEnterDataExtractionMode",
          tabDidEnterDataExtractionMode_encode(v._0)
        ];
}

function response_decode$24(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "TabDidEnterDataExtractionMode") {
    if (tagged.length !== 2) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    }
    var v0 = tabDidEnterDataExtractionMode_decode(Belt_Array.getExn(jsonArr$1, 1));
    if (v0.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: /* TabDidEnterDataExtractionMode */{
                _0: v0._0
              }
            };
    }
    var e = v0._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: "[0]" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskTabToEnterDataExtractionMode = {
  message_encode: message_encode$24,
  message_decode: message_decode$24,
  response_encode: response_encode$24,
  response_decode: response_decode$24,
  tabDidEnterDataExtractionMode_encode: tabDidEnterDataExtractionMode_encode,
  tabDidEnterDataExtractionMode_decode: tabDidEnterDataExtractionMode_decode
};

function message_encode$25(v) {
  return ["AskTabToExitDataExtractionMode"];
}

function message_decode$25(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "AskTabToExitDataExtractionMode") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* AskTabToExitDataExtractionMode */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$25(v) {
  return ["TabDidExitDataExtractionMode"];
}

function response_decode$25(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0 && match._0 === "TabDidExitDataExtractionMode") {
    if (tagged.length !== 1) {
      return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
    } else {
      return {
              TAG: /* Ok */0,
              _0: /* TabDidExitDataExtractionMode */0
            };
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_AskTabToExitDataExtractionMode = {
  message_encode: message_encode$25,
  message_decode: message_decode$25,
  response_encode: response_encode$25,
  response_decode: response_decode$25
};

function message_encode$26(v) {
  switch (v.TAG | 0) {
    case /* Message_StartStreamingEventsToBackground */0 :
        return [
                "Message_StartStreamingEventsToBackground",
                ["StartStreamingEventsToBackground"]
              ];
    case /* Message_StopStreamingEventsToBackground */1 :
        return [
                "Message_StopStreamingEventsToBackground",
                ["StopStreamingEventsToBackground"]
              ];
    case /* Message_Playback */2 :
        return [
                "Message_Playback",
                message_encode$2(v._0)
              ];
    case /* Message_PlaybackExited */3 :
        return [
                "Message_PlaybackExited",
                ["PlaybackExited"]
              ];
    case /* Message_RenderInContentScript */4 :
        return [
                "Message_RenderInContentScript",
                message_encode$4(v._0)
              ];
    case /* Message_AskContentScriptToAdjustModalGeometry */5 :
        return [
                "Message_AskContentScriptToAdjustModalGeometry",
                message_encode$5(v._0)
              ];
    case /* Message_AskContentScriptToEnterUrlTriggeringMode */6 :
        return [
                "Message_AskContentScriptToEnterUrlTriggeringMode",
                message_encode$6(v._0)
              ];
    case /* Message_UrlTriggering_RefreshLinks */7 :
        return [
                "Message_UrlTriggering_RefreshLinks",
                message_encode$7(v._0)
              ];
    case /* Message_UrlTriggering_UpdateLinks */8 :
        return [
                "Message_UrlTriggering_UpdateLinks",
                message_encode$8(v._0)
              ];
    case /* Message_UrlTriggering_TellTabToUpdateLinkGroups */9 :
        return [
                "Message_UrlTriggering_TellTabToUpdateLinkGroups",
                message_encode$9(v._0)
              ];
    case /* Message_UrlTriggering_Exit */10 :
        return [
                "Message_UrlTriggering_Exit",
                ["Exit"]
              ];
    case /* Message_UrlTriggering_AskContentScriptToRecordPageAction */11 :
        return [
                "Message_UrlTriggering_AskContentScriptToRecordPageAction",
                message_encode$11(v._0)
              ];
    case /* Message_UrlTriggering_StopRecordPageAction */12 :
        return [
                "Message_UrlTriggering_StopRecordPageAction",
                ["StopRecordPageAction"]
              ];
    case /* Message_UrlTriggering_PlaybackPageAction */13 :
        return [
                "Message_UrlTriggering_PlaybackPageAction",
                message_encode$13(v._0)
              ];
    case /* Message_UrlTriggering_DidFinishPlaybackPageAction */14 :
        return [
                "Message_UrlTriggering_DidFinishPlaybackPageAction",
                ["DidFinishPlaybackPageAction"]
              ];
    case /* Message_UrlTriggering_ShowLinkWithId */15 :
        return [
                "Message_UrlTriggering_ShowLinkWithId",
                message_encode$15(v._0)
              ];
    case /* Message_UrlTriggering_SendContextLocalAndLinkGroups */16 :
        return [
                "Message_UrlTriggering_SendContextLocalAndLinkGroups",
                ["SendContextLocalAndLinkGroups"]
              ];
    case /* Message_UrlTriggering_PrepareForScreenshot */17 :
        return [
                "Message_UrlTriggering_PrepareForScreenshot",
                ["PrepareForScreenshot"]
              ];
    case /* Message_PingTab */18 :
        return [
                "Message_PingTab",
                ["Ping"]
              ];
    case /* Message_DoesElementExistOnPage */19 :
        return [
                "Message_DoesElementExistOnPage",
                message_encode$19(v._0)
              ];
    case /* Message_AskTabToRenderModalToExplainHighlightElement */20 :
        return [
                "Message_AskTabToRenderModalToExplainHighlightElement",
                ["AskTabToRenderModalToExplainHighlightElement"]
              ];
    case /* Message_AskTabToSetupHighlightElementControl */21 :
        return [
                "Message_AskTabToSetupHighlightElementControl",
                message_encode$21(v._0)
              ];
    case /* Message_AskTabToTeardownHighlightElementControl */22 :
        return [
                "Message_AskTabToTeardownHighlightElementControl",
                ["AskTabToTeardownHighlightElementControl"]
              ];
    case /* Message_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */23 :
        return [
                "Message_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand",
                ["AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand"]
              ];
    case /* Message_AskTabToEnterDataExtractionMode */24 :
        return [
                "Message_AskTabToEnterDataExtractionMode",
                ["AskTabToEnterDataExtractionMode"]
              ];
    case /* Message_AskTabToExitDataExtractionMode */25 :
        return [
                "Message_AskTabToExitDataExtractionMode",
                ["AskTabToExitDataExtractionMode"]
              ];
    
  }
}

function message_decode$26(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Message_AskContentScriptToAdjustModalGeometry" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = message_decode$5(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskContentScriptToAdjustModalGeometry */5,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Message_AskContentScriptToEnterUrlTriggeringMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = message_decode$6(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskContentScriptToEnterUrlTriggeringMode */6,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Message_AskTabToEnterDataExtractionMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = message_decode$24(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskTabToEnterDataExtractionMode */24,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "Message_AskTabToExitDataExtractionMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = message_decode$25(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskTabToExitDataExtractionMode */25,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Message_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = message_decode$23(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */23,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "Message_AskTabToRenderModalToExplainHighlightElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = message_decode$20(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskTabToRenderModalToExplainHighlightElement */20,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "Message_AskTabToSetupHighlightElementControl" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = message_decode$21(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskTabToSetupHighlightElementControl */21,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "Message_AskTabToTeardownHighlightElementControl" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = message_decode$22(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_AskTabToTeardownHighlightElementControl */22,
                      _0: v0$7._0
                    }
                  };
          }
          var e$7 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "Message_DoesElementExistOnPage" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = message_decode$19(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_DoesElementExistOnPage */19,
                      _0: v0$8._0
                    }
                  };
          }
          var e$8 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "Message_PingTab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = message_decode$18(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_PingTab */18,
                      _0: v0$9._0
                    }
                  };
          }
          var e$9 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "Message_Playback" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = message_decode$2(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_Playback */2,
                      _0: v0$10._0
                    }
                  };
          }
          var e$10 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "Message_PlaybackExited" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$11 = message_decode$3(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$11.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_PlaybackExited */3,
                      _0: v0$11._0
                    }
                  };
          }
          var e$11 = v0$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "Message_RenderInContentScript" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$12 = message_decode$4(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$12.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_RenderInContentScript */4,
                      _0: v0$12._0
                    }
                  };
          }
          var e$12 = v0$12._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "Message_StartStreamingEventsToBackground" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$13 = message_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$13.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_StartStreamingEventsToBackground */0,
                      _0: v0$13._0
                    }
                  };
          }
          var e$13 = v0$13._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "Message_StopStreamingEventsToBackground" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$14 = message_decode$1(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$14.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_StopStreamingEventsToBackground */1,
                      _0: v0$14._0
                    }
                  };
          }
          var e$14 = v0$14._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      case "Message_UrlTriggering_AskContentScriptToRecordPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$15 = message_decode$11(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$15.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_AskContentScriptToRecordPageAction */11,
                      _0: v0$15._0
                    }
                  };
          }
          var e$15 = v0$15._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
      case "Message_UrlTriggering_DidFinishPlaybackPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$16 = message_decode$14(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$16.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_DidFinishPlaybackPageAction */14,
                      _0: v0$16._0
                    }
                  };
          }
          var e$16 = v0$16._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                  }
                };
      case "Message_UrlTriggering_Exit" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$17 = message_decode$10(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$17.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_Exit */10,
                      _0: v0$17._0
                    }
                  };
          }
          var e$17 = v0$17._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "Message_UrlTriggering_PlaybackPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$18 = message_decode$13(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$18.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_PlaybackPageAction */13,
                      _0: v0$18._0
                    }
                  };
          }
          var e$18 = v0$18._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                  }
                };
      case "Message_UrlTriggering_PrepareForScreenshot" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$19 = message_decode$17(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$19.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_PrepareForScreenshot */17,
                      _0: v0$19._0
                    }
                  };
          }
          var e$19 = v0$19._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$19.path,
                    message: e$19.message,
                    value: e$19.value
                  }
                };
      case "Message_UrlTriggering_RefreshLinks" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$20 = message_decode$7(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$20.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_RefreshLinks */7,
                      _0: v0$20._0
                    }
                  };
          }
          var e$20 = v0$20._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                  }
                };
      case "Message_UrlTriggering_SendContextLocalAndLinkGroups" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$21 = message_decode$16(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$21.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_SendContextLocalAndLinkGroups */16,
                      _0: v0$21._0
                    }
                  };
          }
          var e$21 = v0$21._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$21.path,
                    message: e$21.message,
                    value: e$21.value
                  }
                };
      case "Message_UrlTriggering_ShowLinkWithId" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$22 = message_decode$15(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$22.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_ShowLinkWithId */15,
                      _0: v0$22._0
                    }
                  };
          }
          var e$22 = v0$22._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$22.path,
                    message: e$22.message,
                    value: e$22.value
                  }
                };
      case "Message_UrlTriggering_StopRecordPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$23 = message_decode$12(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$23.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_StopRecordPageAction */12,
                      _0: v0$23._0
                    }
                  };
          }
          var e$23 = v0$23._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$23.path,
                    message: e$23.message,
                    value: e$23.value
                  }
                };
      case "Message_UrlTriggering_TellTabToUpdateLinkGroups" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$24 = message_decode$9(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$24.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_TellTabToUpdateLinkGroups */9,
                      _0: v0$24._0
                    }
                  };
          }
          var e$24 = v0$24._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$24.path,
                    message: e$24.message,
                    value: e$24.value
                  }
                };
      case "Message_UrlTriggering_UpdateLinks" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$25 = message_decode$8(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$25.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Message_UrlTriggering_UpdateLinks */8,
                      _0: v0$25._0
                    }
                  };
          }
          var e$25 = v0$25._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$25.path,
                    message: e$25.message,
                    value: e$25.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

function response_encode$26(v) {
  switch (v.TAG | 0) {
    case /* Response_StartStreamingEventsToBackground */0 :
        return [
                "Response_StartStreamingEventsToBackground",
                ["TabDidSetupEventStreaming"]
              ];
    case /* Response_StopStreamingEventsToBackground */1 :
        return [
                "Response_StopStreamingEventsToBackground",
                ["TabDidStopStreamingEventsToBackground"]
              ];
    case /* Response_Playback */2 :
        return [
                "Response_Playback",
                response_encode$2(v._0)
              ];
    case /* Response_PlaybackExited */3 :
        return [
                "Response_PlaybackExited",
                ["AckPlaybackExited"]
              ];
    case /* Response_RenderInContentScript */4 :
        return [
                "Response_RenderInContentScript",
                ["AckRenderInContentScript"]
              ];
    case /* Response_AskContentScriptToAdjustModalGeometry */5 :
        return [
                "Response_AskContentScriptToAdjustModalGeometry",
                response_encode$5(v._0)
              ];
    case /* Response_AskContentScriptToEnterUrlTriggeringMode */6 :
        return [
                "Response_AskContentScriptToEnterUrlTriggeringMode",
                response_encode$6(v._0)
              ];
    case /* Response_UrlTriggering_RefreshLinks */7 :
        return [
                "Response_UrlTriggering_RefreshLinks",
                response_encode$7(v._0)
              ];
    case /* Response_UrlTriggering_UpdateLinks */8 :
        return [
                "Response_UrlTriggering_UpdateLinks",
                ["AckLinksUpdated"]
              ];
    case /* Response_UrlTriggering_TellTabToUpdateLinkGroups */9 :
        return [
                "Response_UrlTriggering_TellTabToUpdateLinkGroups",
                ["AckUpdateLinkGroups"]
              ];
    case /* Response_UrlTriggering_Exit */10 :
        return [
                "Response_UrlTriggering_Exit",
                ["AckExit"]
              ];
    case /* Response_UrlTriggering_AskContentScriptToRecordPageAction */11 :
        return [
                "Response_UrlTriggering_AskContentScriptToRecordPageAction",
                ["ContentScriptDidRecordPageAction"]
              ];
    case /* Response_UrlTriggering_StopRecordPageAction */12 :
        return [
                "Response_UrlTriggering_StopRecordPageAction",
                ["AckStopRecordPageAction"]
              ];
    case /* Response_UrlTriggering_PlaybackPageAction */13 :
        return [
                "Response_UrlTriggering_PlaybackPageAction",
                ["AckPlaybackPageAction"]
              ];
    case /* Response_UrlTriggering_DidFinishPlaybackPageAction */14 :
        return [
                "Response_UrlTriggering_DidFinishPlaybackPageAction",
                ["AckDidFinishPlaybackPageAction"]
              ];
    case /* Response_UrlTriggering_ShowLinkWithId */15 :
        return [
                "Response_UrlTriggering_ShowLinkWithId",
                ["AckShowLinkWithId"]
              ];
    case /* Response_UrlTriggering_SendContextLocalAndLinkGroups */16 :
        return [
                "Response_UrlTriggering_SendContextLocalAndLinkGroups",
                response_encode$16(v._0)
              ];
    case /* Response_UrlTriggering_PrepareForScreenshot */17 :
        return [
                "Response_UrlTriggering_PrepareForScreenshot",
                ["AckPrepareForScreenshot"]
              ];
    case /* Response_PingTab */18 :
        return [
                "Response_PingTab",
                ["Ack"]
              ];
    case /* Response_DoesElementExistOnPage */19 :
        return [
                "Response_DoesElementExistOnPage",
                response_encode$19(v._0)
              ];
    case /* Response_AskTabToRenderModalToExplainHighlightElement */20 :
        return [
                "Response_AskTabToRenderModalToExplainHighlightElement",
                ["AckRenderModalToExplainHighlightElement"]
              ];
    case /* Response_AskTabToSetupHighlightElementControl */21 :
        return [
                "Response_AskTabToSetupHighlightElementControl",
                ["DidSetupHighlightElementControl"]
              ];
    case /* Response_AskTabToTeardownHighlightElementControl */22 :
        return [
                "Response_AskTabToTeardownHighlightElementControl",
                ["DidTeardownHighlightElementControl"]
              ];
    case /* Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */23 :
        return [
                "Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand",
                ["DidHideSmartcutsPlaybackModalUntilCompletedCommand"]
              ];
    case /* Response_AskTabToEnterDataExtractionMode */24 :
        return [
                "Response_AskTabToEnterDataExtractionMode",
                response_encode$24(v._0)
              ];
    case /* Response_AskTabToExitDataExtractionMode */25 :
        return [
                "Response_AskTabToExitDataExtractionMode",
                ["TabDidExitDataExtractionMode"]
              ];
    
  }
}

function response_decode$26(v) {
  var jsonArr = Js_json.classify(v);
  if (typeof jsonArr === "number") {
    return Decco.error(undefined, "Not a variant", v);
  }
  if (jsonArr.TAG !== /* JSONArray */3) {
    return Decco.error(undefined, "Not a variant", v);
  }
  var jsonArr$1 = jsonArr._0;
  if (jsonArr$1.length === 0) {
    return Decco.error(undefined, "Expected variant, found empty array", v);
  }
  var tagged = jsonArr$1.map(Js_json.classify);
  var match = Belt_Array.getExn(tagged, 0);
  if (typeof match !== "number" && match.TAG === /* JSONString */0) {
    switch (match._0) {
      case "Response_AskContentScriptToAdjustModalGeometry" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0 = response_decode$5(Belt_Array.getExn(jsonArr$1, 1));
          if (v0.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskContentScriptToAdjustModalGeometry */5,
                      _0: v0._0
                    }
                  };
          }
          var e = v0._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
      case "Response_AskContentScriptToEnterUrlTriggeringMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$1 = response_decode$6(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$1.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskContentScriptToEnterUrlTriggeringMode */6,
                      _0: v0$1._0
                    }
                  };
          }
          var e$1 = v0$1._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$1.path,
                    message: e$1.message,
                    value: e$1.value
                  }
                };
      case "Response_AskTabToEnterDataExtractionMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$2 = response_decode$24(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$2.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskTabToEnterDataExtractionMode */24,
                      _0: v0$2._0
                    }
                  };
          }
          var e$2 = v0$2._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
      case "Response_AskTabToExitDataExtractionMode" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$3 = response_decode$25(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$3.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskTabToExitDataExtractionMode */25,
                      _0: v0$3._0
                    }
                  };
          }
          var e$3 = v0$3._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
      case "Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$4 = response_decode$23(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$4.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */23,
                      _0: v0$4._0
                    }
                  };
          }
          var e$4 = v0$4._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$4.path,
                    message: e$4.message,
                    value: e$4.value
                  }
                };
      case "Response_AskTabToRenderModalToExplainHighlightElement" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$5 = response_decode$20(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$5.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskTabToRenderModalToExplainHighlightElement */20,
                      _0: v0$5._0
                    }
                  };
          }
          var e$5 = v0$5._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$5.path,
                    message: e$5.message,
                    value: e$5.value
                  }
                };
      case "Response_AskTabToSetupHighlightElementControl" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$6 = response_decode$21(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$6.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskTabToSetupHighlightElementControl */21,
                      _0: v0$6._0
                    }
                  };
          }
          var e$6 = v0$6._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$6.path,
                    message: e$6.message,
                    value: e$6.value
                  }
                };
      case "Response_AskTabToTeardownHighlightElementControl" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$7 = response_decode$22(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$7.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_AskTabToTeardownHighlightElementControl */22,
                      _0: v0$7._0
                    }
                  };
          }
          var e$7 = v0$7._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$7.path,
                    message: e$7.message,
                    value: e$7.value
                  }
                };
      case "Response_DoesElementExistOnPage" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$8 = response_decode$19(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$8.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_DoesElementExistOnPage */19,
                      _0: v0$8._0
                    }
                  };
          }
          var e$8 = v0$8._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$8.path,
                    message: e$8.message,
                    value: e$8.value
                  }
                };
      case "Response_PingTab" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$9 = response_decode$18(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$9.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_PingTab */18,
                      _0: v0$9._0
                    }
                  };
          }
          var e$9 = v0$9._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$9.path,
                    message: e$9.message,
                    value: e$9.value
                  }
                };
      case "Response_Playback" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$10 = response_decode$2(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$10.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_Playback */2,
                      _0: v0$10._0
                    }
                  };
          }
          var e$10 = v0$10._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$10.path,
                    message: e$10.message,
                    value: e$10.value
                  }
                };
      case "Response_PlaybackExited" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$11 = response_decode$3(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$11.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_PlaybackExited */3,
                      _0: v0$11._0
                    }
                  };
          }
          var e$11 = v0$11._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$11.path,
                    message: e$11.message,
                    value: e$11.value
                  }
                };
      case "Response_RenderInContentScript" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$12 = response_decode$4(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$12.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_RenderInContentScript */4,
                      _0: v0$12._0
                    }
                  };
          }
          var e$12 = v0$12._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$12.path,
                    message: e$12.message,
                    value: e$12.value
                  }
                };
      case "Response_StartStreamingEventsToBackground" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$13 = response_decode(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$13.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_StartStreamingEventsToBackground */0,
                      _0: v0$13._0
                    }
                  };
          }
          var e$13 = v0$13._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$13.path,
                    message: e$13.message,
                    value: e$13.value
                  }
                };
      case "Response_StopStreamingEventsToBackground" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$14 = response_decode$1(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$14.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_StopStreamingEventsToBackground */1,
                      _0: v0$14._0
                    }
                  };
          }
          var e$14 = v0$14._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$14.path,
                    message: e$14.message,
                    value: e$14.value
                  }
                };
      case "Response_UrlTriggering_AskContentScriptToRecordPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$15 = response_decode$11(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$15.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_AskContentScriptToRecordPageAction */11,
                      _0: v0$15._0
                    }
                  };
          }
          var e$15 = v0$15._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$15.path,
                    message: e$15.message,
                    value: e$15.value
                  }
                };
      case "Response_UrlTriggering_DidFinishPlaybackPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$16 = response_decode$14(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$16.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_DidFinishPlaybackPageAction */14,
                      _0: v0$16._0
                    }
                  };
          }
          var e$16 = v0$16._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$16.path,
                    message: e$16.message,
                    value: e$16.value
                  }
                };
      case "Response_UrlTriggering_Exit" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$17 = response_decode$10(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$17.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_Exit */10,
                      _0: v0$17._0
                    }
                  };
          }
          var e$17 = v0$17._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$17.path,
                    message: e$17.message,
                    value: e$17.value
                  }
                };
      case "Response_UrlTriggering_PlaybackPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$18 = response_decode$13(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$18.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_PlaybackPageAction */13,
                      _0: v0$18._0
                    }
                  };
          }
          var e$18 = v0$18._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$18.path,
                    message: e$18.message,
                    value: e$18.value
                  }
                };
      case "Response_UrlTriggering_PrepareForScreenshot" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$19 = response_decode$17(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$19.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_PrepareForScreenshot */17,
                      _0: v0$19._0
                    }
                  };
          }
          var e$19 = v0$19._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$19.path,
                    message: e$19.message,
                    value: e$19.value
                  }
                };
      case "Response_UrlTriggering_RefreshLinks" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$20 = response_decode$7(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$20.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_RefreshLinks */7,
                      _0: v0$20._0
                    }
                  };
          }
          var e$20 = v0$20._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$20.path,
                    message: e$20.message,
                    value: e$20.value
                  }
                };
      case "Response_UrlTriggering_SendContextLocalAndLinkGroups" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$21 = response_decode$16(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$21.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_SendContextLocalAndLinkGroups */16,
                      _0: v0$21._0
                    }
                  };
          }
          var e$21 = v0$21._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$21.path,
                    message: e$21.message,
                    value: e$21.value
                  }
                };
      case "Response_UrlTriggering_ShowLinkWithId" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$22 = response_decode$15(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$22.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_ShowLinkWithId */15,
                      _0: v0$22._0
                    }
                  };
          }
          var e$22 = v0$22._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$22.path,
                    message: e$22.message,
                    value: e$22.value
                  }
                };
      case "Response_UrlTriggering_StopRecordPageAction" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$23 = response_decode$12(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$23.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_StopRecordPageAction */12,
                      _0: v0$23._0
                    }
                  };
          }
          var e$23 = v0$23._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$23.path,
                    message: e$23.message,
                    value: e$23.value
                  }
                };
      case "Response_UrlTriggering_TellTabToUpdateLinkGroups" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$24 = response_decode$9(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$24.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_TellTabToUpdateLinkGroups */9,
                      _0: v0$24._0
                    }
                  };
          }
          var e$24 = v0$24._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$24.path,
                    message: e$24.message,
                    value: e$24.value
                  }
                };
      case "Response_UrlTriggering_UpdateLinks" :
          if (tagged.length !== 2) {
            return Decco.error(undefined, "Invalid number of arguments to variant constructor", v);
          }
          var v0$25 = response_decode$8(Belt_Array.getExn(jsonArr$1, 1));
          if (v0$25.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      TAG: /* Response_UrlTriggering_UpdateLinks */8,
                      _0: v0$25._0
                    }
                  };
          }
          var e$25 = v0$25._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: "[0]" + e$25.path,
                    message: e$25.message,
                    value: e$25.value
                  }
                };
      default:
        
    }
  }
  return Decco.error(undefined, "Invalid variant constructor", Belt_Array.getExn(jsonArr$1, 0));
}

var MR_All = {
  message_encode: message_encode$26,
  message_decode: message_decode$26,
  response_encode: response_encode$26,
  response_decode: response_decode$26
};

function message_encode$27(v) {
  return ["StartStreamingEventsToBackground"];
}

var message_decode$27 = message_decode;

function response_encode$27(v) {
  return ["TabDidSetupEventStreaming"];
}

var response_decode$27 = response_decode;

var allMessage_encode = message_encode$26;

var allMessage_decode = message_decode$26;

var allResponse_encode = response_encode$26;

var allResponse_decode = response_decode$26;

function responseError_encode(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage(message) {
  return {
          TAG: /* Message_StartStreamingEventsToBackground */0,
          _0: message
        };
}

function unwrapAllResponseAsResponse(allResponse) {
  if (allResponse.TAG === /* Response_StartStreamingEventsToBackground */0) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse(response) {
  return {
          TAG: /* Response_StartStreamingEventsToBackground */0,
          _0: response
        };
}

var MRTransform_StartStreamingEventsToBackground = {
  message_encode: message_encode$27,
  message_decode: message_decode$27,
  response_encode: response_encode$27,
  response_decode: response_decode$27,
  allMessage_encode: allMessage_encode,
  allMessage_decode: allMessage_decode,
  allResponse_encode: allResponse_encode,
  allResponse_decode: allResponse_decode,
  responseError_encode: responseError_encode,
  responseError_decode: responseError_decode,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse
};

var StartStreamingEventsToBackground = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_StartStreamingEventsToBackground);

function message_encode$28(v) {
  return ["StopStreamingEventsToBackground"];
}

var message_decode$28 = message_decode$1;

function response_encode$28(v) {
  return ["TabDidStopStreamingEventsToBackground"];
}

var response_decode$28 = response_decode$1;

var allMessage_encode$1 = message_encode$26;

var allMessage_decode$1 = message_decode$26;

var allResponse_encode$1 = response_encode$26;

var allResponse_decode$1 = response_decode$26;

function responseError_encode$1(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$1(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$1(message) {
  return {
          TAG: /* Message_StopStreamingEventsToBackground */1,
          _0: message
        };
}

function unwrapAllResponseAsResponse$1(allResponse) {
  if (allResponse.TAG === /* Response_StopStreamingEventsToBackground */1) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$1(response) {
  return {
          TAG: /* Response_StopStreamingEventsToBackground */1,
          _0: response
        };
}

var MRTransform_StopStreamingEventsToBackground = {
  message_encode: message_encode$28,
  message_decode: message_decode$28,
  response_encode: response_encode$28,
  response_decode: response_decode$28,
  allMessage_encode: allMessage_encode$1,
  allMessage_decode: allMessage_decode$1,
  allResponse_encode: allResponse_encode$1,
  allResponse_decode: allResponse_decode$1,
  responseError_encode: responseError_encode$1,
  responseError_decode: responseError_decode$1,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$1,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$1,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$1
};

var StopStreamingEventsToBackground = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_StopStreamingEventsToBackground);

var message_encode$29 = message_encode$2;

var message_decode$29 = message_decode$2;

var response_encode$29 = response_encode$2;

var response_decode$29 = response_decode$2;

var allMessage_encode$2 = message_encode$26;

var allMessage_decode$2 = message_decode$26;

var allResponse_encode$2 = response_encode$26;

var allResponse_decode$2 = response_decode$26;

function responseError_encode$2(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$2(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$2(message) {
  return {
          TAG: /* Message_Playback */2,
          _0: message
        };
}

function unwrapAllResponseAsResponse$2(allResponse) {
  if (allResponse.TAG === /* Response_Playback */2) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$2(response) {
  return {
          TAG: /* Response_Playback */2,
          _0: response
        };
}

var MRTransform_Playback = {
  message_encode: message_encode$29,
  message_decode: message_decode$29,
  response_encode: response_encode$29,
  response_decode: response_decode$29,
  allMessage_encode: allMessage_encode$2,
  allMessage_decode: allMessage_decode$2,
  allResponse_encode: allResponse_encode$2,
  allResponse_decode: allResponse_decode$2,
  responseError_encode: responseError_encode$2,
  responseError_decode: responseError_decode$2,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$2,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$2,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$2
};

var Playback = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_Playback);

function message_encode$30(v) {
  return ["PlaybackExited"];
}

var message_decode$30 = message_decode$3;

function response_encode$30(v) {
  return ["AckPlaybackExited"];
}

var response_decode$30 = response_decode$3;

var allMessage_encode$3 = message_encode$26;

var allMessage_decode$3 = message_decode$26;

var allResponse_encode$3 = response_encode$26;

var allResponse_decode$3 = response_decode$26;

function responseError_encode$3(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$3(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$3(message) {
  return {
          TAG: /* Message_PlaybackExited */3,
          _0: message
        };
}

function unwrapAllResponseAsResponse$3(allResponse) {
  if (allResponse.TAG === /* Response_PlaybackExited */3) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$3(response) {
  return {
          TAG: /* Response_PlaybackExited */3,
          _0: response
        };
}

var MRTransform_PlaybackExited = {
  message_encode: message_encode$30,
  message_decode: message_decode$30,
  response_encode: response_encode$30,
  response_decode: response_decode$30,
  allMessage_encode: allMessage_encode$3,
  allMessage_decode: allMessage_decode$3,
  allResponse_encode: allResponse_encode$3,
  allResponse_decode: allResponse_decode$3,
  responseError_encode: responseError_encode$3,
  responseError_decode: responseError_decode$3,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$3,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$3,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$3
};

var PlaybackExited = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_PlaybackExited);

var message_encode$31 = message_encode$4;

var message_decode$31 = message_decode$4;

function response_encode$31(v) {
  return ["AckRenderInContentScript"];
}

var response_decode$31 = response_decode$4;

var allMessage_encode$4 = message_encode$26;

var allMessage_decode$4 = message_decode$26;

var allResponse_encode$4 = response_encode$26;

var allResponse_decode$4 = response_decode$26;

function responseError_encode$4(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$4(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$4(message) {
  return {
          TAG: /* Message_RenderInContentScript */4,
          _0: message
        };
}

function unwrapAllResponseAsResponse$4(allResponse) {
  if (allResponse.TAG === /* Response_RenderInContentScript */4) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$4(response) {
  return {
          TAG: /* Response_RenderInContentScript */4,
          _0: response
        };
}

var MRTransform_RenderInContentScript = {
  message_encode: message_encode$31,
  message_decode: message_decode$31,
  response_encode: response_encode$31,
  response_decode: response_decode$31,
  allMessage_encode: allMessage_encode$4,
  allMessage_decode: allMessage_decode$4,
  allResponse_encode: allResponse_encode$4,
  allResponse_decode: allResponse_decode$4,
  responseError_encode: responseError_encode$4,
  responseError_decode: responseError_decode$4,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$4,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$4,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$4
};

var RenderInContentScript = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_RenderInContentScript);

var message_encode$32 = message_encode$5;

var message_decode$32 = message_decode$5;

var response_encode$32 = response_encode$5;

var response_decode$32 = response_decode$5;

var allMessage_encode$5 = message_encode$26;

var allMessage_decode$5 = message_decode$26;

var allResponse_encode$5 = response_encode$26;

var allResponse_decode$5 = response_decode$26;

function responseError_encode$5(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$5(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$5(message) {
  return {
          TAG: /* Message_AskContentScriptToAdjustModalGeometry */5,
          _0: message
        };
}

function unwrapAllResponseAsResponse$5(allResponse) {
  if (allResponse.TAG === /* Response_AskContentScriptToAdjustModalGeometry */5) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$5(response) {
  return {
          TAG: /* Response_AskContentScriptToAdjustModalGeometry */5,
          _0: response
        };
}

var MRTransform_AskContentScriptToAdjustModalGeometry = {
  message_encode: message_encode$32,
  message_decode: message_decode$32,
  response_encode: response_encode$32,
  response_decode: response_decode$32,
  allMessage_encode: allMessage_encode$5,
  allMessage_decode: allMessage_decode$5,
  allResponse_encode: allResponse_encode$5,
  allResponse_decode: allResponse_decode$5,
  responseError_encode: responseError_encode$5,
  responseError_decode: responseError_decode$5,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$5,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$5,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$5
};

var AskContentScriptToAdjustModalGeometry = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskContentScriptToAdjustModalGeometry);

var message_encode$33 = message_encode$6;

var message_decode$33 = message_decode$6;

var response_encode$33 = response_encode$6;

var response_decode$33 = response_decode$6;

var allMessage_encode$6 = message_encode$26;

var allMessage_decode$6 = message_decode$26;

var allResponse_encode$6 = response_encode$26;

var allResponse_decode$6 = response_decode$26;

function responseError_encode$6(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$6(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$6(message) {
  return {
          TAG: /* Message_AskContentScriptToEnterUrlTriggeringMode */6,
          _0: message
        };
}

function unwrapAllResponseAsResponse$6(allResponse) {
  if (allResponse.TAG === /* Response_AskContentScriptToEnterUrlTriggeringMode */6) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$6(response) {
  return {
          TAG: /* Response_AskContentScriptToEnterUrlTriggeringMode */6,
          _0: response
        };
}

var MRTransform_AskContentScriptToEnterUrlTriggeringMode = {
  message_encode: message_encode$33,
  message_decode: message_decode$33,
  response_encode: response_encode$33,
  response_decode: response_decode$33,
  allMessage_encode: allMessage_encode$6,
  allMessage_decode: allMessage_decode$6,
  allResponse_encode: allResponse_encode$6,
  allResponse_decode: allResponse_decode$6,
  responseError_encode: responseError_encode$6,
  responseError_decode: responseError_decode$6,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$6,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$6,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$6
};

var AskContentScriptToEnterUrlTriggeringMode = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskContentScriptToEnterUrlTriggeringMode);

var message_encode$34 = message_encode$7;

var message_decode$34 = message_decode$7;

var response_encode$34 = response_encode$7;

var response_decode$34 = response_decode$7;

var allMessage_encode$7 = message_encode$26;

var allMessage_decode$7 = message_decode$26;

var allResponse_encode$7 = response_encode$26;

var allResponse_decode$7 = response_decode$26;

function responseError_encode$7(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$7(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$7(message) {
  return {
          TAG: /* Message_UrlTriggering_RefreshLinks */7,
          _0: message
        };
}

function unwrapAllResponseAsResponse$7(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_RefreshLinks */7) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$7(response) {
  return {
          TAG: /* Response_UrlTriggering_RefreshLinks */7,
          _0: response
        };
}

var MRTransform_UrlTriggering_RefreshLinks = {
  message_encode: message_encode$34,
  message_decode: message_decode$34,
  response_encode: response_encode$34,
  response_decode: response_decode$34,
  allMessage_encode: allMessage_encode$7,
  allMessage_decode: allMessage_decode$7,
  allResponse_encode: allResponse_encode$7,
  allResponse_decode: allResponse_decode$7,
  responseError_encode: responseError_encode$7,
  responseError_decode: responseError_decode$7,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$7,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$7,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$7
};

var UrlTriggering_RefreshLinks = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_RefreshLinks);

var message_encode$35 = message_encode$8;

var message_decode$35 = message_decode$8;

function response_encode$35(v) {
  return ["AckLinksUpdated"];
}

var response_decode$35 = response_decode$8;

var allMessage_encode$8 = message_encode$26;

var allMessage_decode$8 = message_decode$26;

var allResponse_encode$8 = response_encode$26;

var allResponse_decode$8 = response_decode$26;

function responseError_encode$8(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$8(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$8(message) {
  return {
          TAG: /* Message_UrlTriggering_UpdateLinks */8,
          _0: message
        };
}

function unwrapAllResponseAsResponse$8(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_UpdateLinks */8) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$8(response) {
  return {
          TAG: /* Response_UrlTriggering_UpdateLinks */8,
          _0: response
        };
}

var MRTransform_UrlTriggering_UpdateLinks = {
  message_encode: message_encode$35,
  message_decode: message_decode$35,
  response_encode: response_encode$35,
  response_decode: response_decode$35,
  allMessage_encode: allMessage_encode$8,
  allMessage_decode: allMessage_decode$8,
  allResponse_encode: allResponse_encode$8,
  allResponse_decode: allResponse_decode$8,
  responseError_encode: responseError_encode$8,
  responseError_decode: responseError_decode$8,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$8,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$8,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$8
};

var UrlTriggering_UpdateLinks = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_UpdateLinks);

var message_encode$36 = message_encode$9;

var message_decode$36 = message_decode$9;

function response_encode$36(v) {
  return ["AckUpdateLinkGroups"];
}

var response_decode$36 = response_decode$9;

var allMessage_encode$9 = message_encode$26;

var allMessage_decode$9 = message_decode$26;

var allResponse_encode$9 = response_encode$26;

var allResponse_decode$9 = response_decode$26;

function responseError_encode$9(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$9(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$9(message) {
  return {
          TAG: /* Message_UrlTriggering_TellTabToUpdateLinkGroups */9,
          _0: message
        };
}

function unwrapAllResponseAsResponse$9(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_TellTabToUpdateLinkGroups */9) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$9(response) {
  return {
          TAG: /* Response_UrlTriggering_TellTabToUpdateLinkGroups */9,
          _0: response
        };
}

var MRTransform_UrlTriggering_TellTabToUpdateLinkGroups = {
  message_encode: message_encode$36,
  message_decode: message_decode$36,
  response_encode: response_encode$36,
  response_decode: response_decode$36,
  allMessage_encode: allMessage_encode$9,
  allMessage_decode: allMessage_decode$9,
  allResponse_encode: allResponse_encode$9,
  allResponse_decode: allResponse_decode$9,
  responseError_encode: responseError_encode$9,
  responseError_decode: responseError_decode$9,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$9,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$9,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$9
};

var UrlTriggering_TellTabToUpdateLinkGroups = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_TellTabToUpdateLinkGroups);

function message_encode$37(v) {
  return ["Exit"];
}

var message_decode$37 = message_decode$10;

function response_encode$37(v) {
  return ["AckExit"];
}

var response_decode$37 = response_decode$10;

var allMessage_encode$10 = message_encode$26;

var allMessage_decode$10 = message_decode$26;

var allResponse_encode$10 = response_encode$26;

var allResponse_decode$10 = response_decode$26;

function responseError_encode$10(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$10(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$10(message) {
  return {
          TAG: /* Message_UrlTriggering_Exit */10,
          _0: message
        };
}

function unwrapAllResponseAsResponse$10(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_Exit */10) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$10(response) {
  return {
          TAG: /* Response_UrlTriggering_Exit */10,
          _0: response
        };
}

var MRTransform_UrlTriggering_Exit = {
  message_encode: message_encode$37,
  message_decode: message_decode$37,
  response_encode: response_encode$37,
  response_decode: response_decode$37,
  allMessage_encode: allMessage_encode$10,
  allMessage_decode: allMessage_decode$10,
  allResponse_encode: allResponse_encode$10,
  allResponse_decode: allResponse_decode$10,
  responseError_encode: responseError_encode$10,
  responseError_decode: responseError_decode$10,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$10,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$10,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$10
};

var UrlTriggering_Exit = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_Exit);

var message_encode$38 = message_encode$11;

var message_decode$38 = message_decode$11;

function response_encode$38(v) {
  return ["ContentScriptDidRecordPageAction"];
}

var response_decode$38 = response_decode$11;

var allMessage_encode$11 = message_encode$26;

var allMessage_decode$11 = message_decode$26;

var allResponse_encode$11 = response_encode$26;

var allResponse_decode$11 = response_decode$26;

function responseError_encode$11(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$11(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$11(message) {
  return {
          TAG: /* Message_UrlTriggering_AskContentScriptToRecordPageAction */11,
          _0: message
        };
}

function unwrapAllResponseAsResponse$11(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_AskContentScriptToRecordPageAction */11) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$11(response) {
  return {
          TAG: /* Response_UrlTriggering_AskContentScriptToRecordPageAction */11,
          _0: response
        };
}

var MRTransform_UrlTriggering_AskContentScriptToRecordPageAction = {
  message_encode: message_encode$38,
  message_decode: message_decode$38,
  response_encode: response_encode$38,
  response_decode: response_decode$38,
  allMessage_encode: allMessage_encode$11,
  allMessage_decode: allMessage_decode$11,
  allResponse_encode: allResponse_encode$11,
  allResponse_decode: allResponse_decode$11,
  responseError_encode: responseError_encode$11,
  responseError_decode: responseError_decode$11,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$11,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$11,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$11
};

var UrlTriggering_AskContentScriptToRecordPageAction = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_AskContentScriptToRecordPageAction);

function message_encode$39(v) {
  return ["StopRecordPageAction"];
}

var message_decode$39 = message_decode$12;

function response_encode$39(v) {
  return ["AckStopRecordPageAction"];
}

var response_decode$39 = response_decode$12;

var allMessage_encode$12 = message_encode$26;

var allMessage_decode$12 = message_decode$26;

var allResponse_encode$12 = response_encode$26;

var allResponse_decode$12 = response_decode$26;

function responseError_encode$12(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$12(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$12(message) {
  return {
          TAG: /* Message_UrlTriggering_StopRecordPageAction */12,
          _0: message
        };
}

function unwrapAllResponseAsResponse$12(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_StopRecordPageAction */12) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$12(response) {
  return {
          TAG: /* Response_UrlTriggering_StopRecordPageAction */12,
          _0: response
        };
}

var MRTransform_UrlTriggering_StopRecordPageAction = {
  message_encode: message_encode$39,
  message_decode: message_decode$39,
  response_encode: response_encode$39,
  response_decode: response_decode$39,
  allMessage_encode: allMessage_encode$12,
  allMessage_decode: allMessage_decode$12,
  allResponse_encode: allResponse_encode$12,
  allResponse_decode: allResponse_decode$12,
  responseError_encode: responseError_encode$12,
  responseError_decode: responseError_decode$12,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$12,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$12,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$12
};

var UrlTriggering_StopRecordPageAction = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_StopRecordPageAction);

var message_encode$40 = message_encode$13;

var message_decode$40 = message_decode$13;

function response_encode$40(v) {
  return ["AckPlaybackPageAction"];
}

var response_decode$40 = response_decode$13;

var allMessage_encode$13 = message_encode$26;

var allMessage_decode$13 = message_decode$26;

var allResponse_encode$13 = response_encode$26;

var allResponse_decode$13 = response_decode$26;

function responseError_encode$13(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$13(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$13(message) {
  return {
          TAG: /* Message_UrlTriggering_PlaybackPageAction */13,
          _0: message
        };
}

function unwrapAllResponseAsResponse$13(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_PlaybackPageAction */13) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$13(response) {
  return {
          TAG: /* Response_UrlTriggering_PlaybackPageAction */13,
          _0: response
        };
}

var MRTransform_UrlTriggering_PlaybackPageAction = {
  message_encode: message_encode$40,
  message_decode: message_decode$40,
  response_encode: response_encode$40,
  response_decode: response_decode$40,
  allMessage_encode: allMessage_encode$13,
  allMessage_decode: allMessage_decode$13,
  allResponse_encode: allResponse_encode$13,
  allResponse_decode: allResponse_decode$13,
  responseError_encode: responseError_encode$13,
  responseError_decode: responseError_decode$13,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$13,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$13,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$13
};

var UrlTriggering_PlaybackPageAction = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_PlaybackPageAction);

function message_encode$41(v) {
  return ["DidFinishPlaybackPageAction"];
}

var message_decode$41 = message_decode$14;

function response_encode$41(v) {
  return ["AckDidFinishPlaybackPageAction"];
}

var response_decode$41 = response_decode$14;

var allMessage_encode$14 = message_encode$26;

var allMessage_decode$14 = message_decode$26;

var allResponse_encode$14 = response_encode$26;

var allResponse_decode$14 = response_decode$26;

function responseError_encode$14(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$14(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$14(message) {
  return {
          TAG: /* Message_UrlTriggering_DidFinishPlaybackPageAction */14,
          _0: message
        };
}

function unwrapAllResponseAsResponse$14(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_DidFinishPlaybackPageAction */14) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$14(response) {
  return {
          TAG: /* Response_UrlTriggering_DidFinishPlaybackPageAction */14,
          _0: response
        };
}

var MRTransform_UrlTriggering_DidFinishPlaybackPageAction = {
  message_encode: message_encode$41,
  message_decode: message_decode$41,
  response_encode: response_encode$41,
  response_decode: response_decode$41,
  allMessage_encode: allMessage_encode$14,
  allMessage_decode: allMessage_decode$14,
  allResponse_encode: allResponse_encode$14,
  allResponse_decode: allResponse_decode$14,
  responseError_encode: responseError_encode$14,
  responseError_decode: responseError_decode$14,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$14,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$14,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$14
};

var UrlTriggering_DidFinishPlaybackPageAction = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_DidFinishPlaybackPageAction);

var message_encode$42 = message_encode$15;

var message_decode$42 = message_decode$15;

function response_encode$42(v) {
  return ["AckShowLinkWithId"];
}

var response_decode$42 = response_decode$15;

var allMessage_encode$15 = message_encode$26;

var allMessage_decode$15 = message_decode$26;

var allResponse_encode$15 = response_encode$26;

var allResponse_decode$15 = response_decode$26;

function responseError_encode$15(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$15(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$15(message) {
  return {
          TAG: /* Message_UrlTriggering_ShowLinkWithId */15,
          _0: message
        };
}

function unwrapAllResponseAsResponse$15(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_ShowLinkWithId */15) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$15(response) {
  return {
          TAG: /* Response_UrlTriggering_ShowLinkWithId */15,
          _0: response
        };
}

var MRTransform_UrlTriggering_ShowLinkWithId = {
  message_encode: message_encode$42,
  message_decode: message_decode$42,
  response_encode: response_encode$42,
  response_decode: response_decode$42,
  allMessage_encode: allMessage_encode$15,
  allMessage_decode: allMessage_decode$15,
  allResponse_encode: allResponse_encode$15,
  allResponse_decode: allResponse_decode$15,
  responseError_encode: responseError_encode$15,
  responseError_decode: responseError_decode$15,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$15,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$15,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$15
};

var UrlTriggering_ShowLinkWithId = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_ShowLinkWithId);

function message_encode$43(v) {
  return ["SendContextLocalAndLinkGroups"];
}

var message_decode$43 = message_decode$16;

var response_encode$43 = response_encode$16;

var response_decode$43 = response_decode$16;

var allMessage_encode$16 = message_encode$26;

var allMessage_decode$16 = message_decode$26;

var allResponse_encode$16 = response_encode$26;

var allResponse_decode$16 = response_decode$26;

function responseError_encode$16(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$16(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$16(message) {
  return {
          TAG: /* Message_UrlTriggering_SendContextLocalAndLinkGroups */16,
          _0: message
        };
}

function unwrapAllResponseAsResponse$16(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_SendContextLocalAndLinkGroups */16) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$16(response) {
  return {
          TAG: /* Response_UrlTriggering_SendContextLocalAndLinkGroups */16,
          _0: response
        };
}

var MRTransform_UrlTriggering_SendContextLocalAndLinkGroups = {
  message_encode: message_encode$43,
  message_decode: message_decode$43,
  response_encode: response_encode$43,
  response_decode: response_decode$43,
  allMessage_encode: allMessage_encode$16,
  allMessage_decode: allMessage_decode$16,
  allResponse_encode: allResponse_encode$16,
  allResponse_decode: allResponse_decode$16,
  responseError_encode: responseError_encode$16,
  responseError_decode: responseError_decode$16,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$16,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$16,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$16
};

var UrlTriggering_SendContextLocalAndLinkGroups = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_SendContextLocalAndLinkGroups);

function message_encode$44(v) {
  return ["PrepareForScreenshot"];
}

var message_decode$44 = message_decode$17;

function response_encode$44(v) {
  return ["AckPrepareForScreenshot"];
}

var response_decode$44 = response_decode$17;

var allMessage_encode$17 = message_encode$26;

var allMessage_decode$17 = message_decode$26;

var allResponse_encode$17 = response_encode$26;

var allResponse_decode$17 = response_decode$26;

function responseError_encode$17(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$17(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$17(message) {
  return {
          TAG: /* Message_UrlTriggering_PrepareForScreenshot */17,
          _0: message
        };
}

function unwrapAllResponseAsResponse$17(allResponse) {
  if (allResponse.TAG === /* Response_UrlTriggering_PrepareForScreenshot */17) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$17(response) {
  return {
          TAG: /* Response_UrlTriggering_PrepareForScreenshot */17,
          _0: response
        };
}

var MRTransform_UrlTriggering_PrepareForScreenshot = {
  message_encode: message_encode$44,
  message_decode: message_decode$44,
  response_encode: response_encode$44,
  response_decode: response_decode$44,
  allMessage_encode: allMessage_encode$17,
  allMessage_decode: allMessage_decode$17,
  allResponse_encode: allResponse_encode$17,
  allResponse_decode: allResponse_decode$17,
  responseError_encode: responseError_encode$17,
  responseError_decode: responseError_decode$17,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$17,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$17,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$17
};

var UrlTriggering_PrepareForScreenshot = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_UrlTriggering_PrepareForScreenshot);

function message_encode$45(v) {
  return ["Ping"];
}

var message_decode$45 = message_decode$18;

function response_encode$45(v) {
  return ["Ack"];
}

var response_decode$45 = response_decode$18;

var allMessage_encode$18 = message_encode$26;

var allMessage_decode$18 = message_decode$26;

var allResponse_encode$18 = response_encode$26;

var allResponse_decode$18 = response_decode$26;

function responseError_encode$18(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$18(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$18(message) {
  return {
          TAG: /* Message_PingTab */18,
          _0: message
        };
}

function unwrapAllResponseAsResponse$18(allResponse) {
  if (allResponse.TAG === /* Response_PingTab */18) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$18(response) {
  return {
          TAG: /* Response_PingTab */18,
          _0: response
        };
}

var MRTransform_PingTab = {
  message_encode: message_encode$45,
  message_decode: message_decode$45,
  response_encode: response_encode$45,
  response_decode: response_decode$45,
  allMessage_encode: allMessage_encode$18,
  allMessage_decode: allMessage_decode$18,
  allResponse_encode: allResponse_encode$18,
  allResponse_decode: allResponse_decode$18,
  responseError_encode: responseError_encode$18,
  responseError_decode: responseError_decode$18,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$18,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$18,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$18
};

var PingTab = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_PingTab);

var message_encode$46 = message_encode$19;

var message_decode$46 = message_decode$19;

var response_encode$46 = response_encode$19;

var response_decode$46 = response_decode$19;

var allMessage_encode$19 = message_encode$26;

var allMessage_decode$19 = message_decode$26;

var allResponse_encode$19 = response_encode$26;

var allResponse_decode$19 = response_decode$26;

function responseError_encode$19(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$19(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$19(message) {
  return {
          TAG: /* Message_DoesElementExistOnPage */19,
          _0: message
        };
}

function unwrapAllResponseAsResponse$19(allResponse) {
  if (allResponse.TAG === /* Response_DoesElementExistOnPage */19) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$19(response) {
  return {
          TAG: /* Response_DoesElementExistOnPage */19,
          _0: response
        };
}

var MRTransform_DoesElementExistOnPage = {
  message_encode: message_encode$46,
  message_decode: message_decode$46,
  response_encode: response_encode$46,
  response_decode: response_decode$46,
  allMessage_encode: allMessage_encode$19,
  allMessage_decode: allMessage_decode$19,
  allResponse_encode: allResponse_encode$19,
  allResponse_decode: allResponse_decode$19,
  responseError_encode: responseError_encode$19,
  responseError_decode: responseError_decode$19,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$19,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$19,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$19
};

var DoesElementExistOnPage = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_DoesElementExistOnPage);

function message_encode$47(v) {
  return ["AskTabToRenderModalToExplainHighlightElement"];
}

var message_decode$47 = message_decode$20;

function response_encode$47(v) {
  return ["AckRenderModalToExplainHighlightElement"];
}

var response_decode$47 = response_decode$20;

var allMessage_encode$20 = message_encode$26;

var allMessage_decode$20 = message_decode$26;

var allResponse_encode$20 = response_encode$26;

var allResponse_decode$20 = response_decode$26;

function responseError_encode$20(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$20(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$20(message) {
  return {
          TAG: /* Message_AskTabToRenderModalToExplainHighlightElement */20,
          _0: message
        };
}

function unwrapAllResponseAsResponse$20(allResponse) {
  if (allResponse.TAG === /* Response_AskTabToRenderModalToExplainHighlightElement */20) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$20(response) {
  return {
          TAG: /* Response_AskTabToRenderModalToExplainHighlightElement */20,
          _0: response
        };
}

var MRTransform_AskTabToRenderModalToExplainHighlightElement = {
  message_encode: message_encode$47,
  message_decode: message_decode$47,
  response_encode: response_encode$47,
  response_decode: response_decode$47,
  allMessage_encode: allMessage_encode$20,
  allMessage_decode: allMessage_decode$20,
  allResponse_encode: allResponse_encode$20,
  allResponse_decode: allResponse_decode$20,
  responseError_encode: responseError_encode$20,
  responseError_decode: responseError_decode$20,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$20,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$20,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$20
};

var AskTabToRenderModalToExplainHighlightElement = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskTabToRenderModalToExplainHighlightElement);

var message_encode$48 = message_encode$21;

var message_decode$48 = message_decode$21;

function response_encode$48(v) {
  return ["DidSetupHighlightElementControl"];
}

var response_decode$48 = response_decode$21;

var allMessage_encode$21 = message_encode$26;

var allMessage_decode$21 = message_decode$26;

var allResponse_encode$21 = response_encode$26;

var allResponse_decode$21 = response_decode$26;

function responseError_encode$21(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$21(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$21(message) {
  return {
          TAG: /* Message_AskTabToSetupHighlightElementControl */21,
          _0: message
        };
}

function unwrapAllResponseAsResponse$21(allResponse) {
  if (allResponse.TAG === /* Response_AskTabToSetupHighlightElementControl */21) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$21(response) {
  return {
          TAG: /* Response_AskTabToSetupHighlightElementControl */21,
          _0: response
        };
}

var MRTransform_AskTabToSetupHighlightElementControl = {
  message_encode: message_encode$48,
  message_decode: message_decode$48,
  response_encode: response_encode$48,
  response_decode: response_decode$48,
  allMessage_encode: allMessage_encode$21,
  allMessage_decode: allMessage_decode$21,
  allResponse_encode: allResponse_encode$21,
  allResponse_decode: allResponse_decode$21,
  responseError_encode: responseError_encode$21,
  responseError_decode: responseError_decode$21,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$21,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$21,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$21
};

var AskTabToSetupHighlightElementControl = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskTabToSetupHighlightElementControl);

function message_encode$49(v) {
  return ["AskTabToTeardownHighlightElementControl"];
}

var message_decode$49 = message_decode$22;

function response_encode$49(v) {
  return ["DidTeardownHighlightElementControl"];
}

var response_decode$49 = response_decode$22;

var allMessage_encode$22 = message_encode$26;

var allMessage_decode$22 = message_decode$26;

var allResponse_encode$22 = response_encode$26;

var allResponse_decode$22 = response_decode$26;

function responseError_encode$22(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$22(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$22(message) {
  return {
          TAG: /* Message_AskTabToTeardownHighlightElementControl */22,
          _0: message
        };
}

function unwrapAllResponseAsResponse$22(allResponse) {
  if (allResponse.TAG === /* Response_AskTabToTeardownHighlightElementControl */22) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$22(response) {
  return {
          TAG: /* Response_AskTabToTeardownHighlightElementControl */22,
          _0: response
        };
}

var MRTransform_AskTabToTeardownHighlightElementControl = {
  message_encode: message_encode$49,
  message_decode: message_decode$49,
  response_encode: response_encode$49,
  response_decode: response_decode$49,
  allMessage_encode: allMessage_encode$22,
  allMessage_decode: allMessage_decode$22,
  allResponse_encode: allResponse_encode$22,
  allResponse_decode: allResponse_decode$22,
  responseError_encode: responseError_encode$22,
  responseError_decode: responseError_decode$22,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$22,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$22,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$22
};

var AskTabToTeardownHighlightElementControl = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskTabToTeardownHighlightElementControl);

function message_encode$50(v) {
  return ["AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand"];
}

var message_decode$50 = message_decode$23;

function response_encode$50(v) {
  return ["DidHideSmartcutsPlaybackModalUntilCompletedCommand"];
}

var response_decode$50 = response_decode$23;

var allMessage_encode$23 = message_encode$26;

var allMessage_decode$23 = message_decode$26;

var allResponse_encode$23 = response_encode$26;

var allResponse_decode$23 = response_decode$26;

function responseError_encode$23(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$23(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$23(message) {
  return {
          TAG: /* Message_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */23,
          _0: message
        };
}

function unwrapAllResponseAsResponse$23(allResponse) {
  if (allResponse.TAG === /* Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */23) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$23(response) {
  return {
          TAG: /* Response_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand */23,
          _0: response
        };
}

var MRTransform_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = {
  message_encode: message_encode$50,
  message_decode: message_decode$50,
  response_encode: response_encode$50,
  response_decode: response_decode$50,
  allMessage_encode: allMessage_encode$23,
  allMessage_decode: allMessage_decode$23,
  allResponse_encode: allResponse_encode$23,
  allResponse_decode: allResponse_decode$23,
  responseError_encode: responseError_encode$23,
  responseError_decode: responseError_decode$23,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$23,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$23,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$23
};

var AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand);

function message_encode$51(v) {
  return ["AskTabToEnterDataExtractionMode"];
}

var message_decode$51 = message_decode$24;

var response_encode$51 = response_encode$24;

var response_decode$51 = response_decode$24;

var allMessage_encode$24 = message_encode$26;

var allMessage_decode$24 = message_decode$26;

var allResponse_encode$24 = response_encode$26;

var allResponse_decode$24 = response_decode$26;

function responseError_encode$24(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$24(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$24(message) {
  return {
          TAG: /* Message_AskTabToEnterDataExtractionMode */24,
          _0: message
        };
}

function unwrapAllResponseAsResponse$24(allResponse) {
  if (allResponse.TAG === /* Response_AskTabToEnterDataExtractionMode */24) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$24(response) {
  return {
          TAG: /* Response_AskTabToEnterDataExtractionMode */24,
          _0: response
        };
}

var MRTransform_AskTabToEnterDataExtractionMode = {
  message_encode: message_encode$51,
  message_decode: message_decode$51,
  response_encode: response_encode$51,
  response_decode: response_decode$51,
  allMessage_encode: allMessage_encode$24,
  allMessage_decode: allMessage_decode$24,
  allResponse_encode: allResponse_encode$24,
  allResponse_decode: allResponse_decode$24,
  responseError_encode: responseError_encode$24,
  responseError_decode: responseError_decode$24,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$24,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$24,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$24
};

var AskTabToEnterDataExtractionMode = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskTabToEnterDataExtractionMode);

function message_encode$52(v) {
  return ["AskTabToExitDataExtractionMode"];
}

var message_decode$52 = message_decode$25;

function response_encode$52(v) {
  return ["TabDidExitDataExtractionMode"];
}

var response_decode$52 = response_decode$25;

var allMessage_encode$25 = message_encode$26;

var allMessage_decode$25 = message_decode$26;

var allResponse_encode$25 = response_encode$26;

var allResponse_decode$25 = response_decode$26;

function responseError_encode$25(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$25(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function wrapMessageAsAllMessage$25(message) {
  return {
          TAG: /* Message_AskTabToExitDataExtractionMode */25,
          _0: message
        };
}

function unwrapAllResponseAsResponse$25(allResponse) {
  if (allResponse.TAG === /* Response_AskTabToExitDataExtractionMode */25) {
    return allResponse._0;
  } else {
    return Util$SmartcutsMacros.logAndRaiseJsError("Invalid allResponse for conditions");
  }
}

function wrapResponseAsAllResponse$25(response) {
  return {
          TAG: /* Response_AskTabToExitDataExtractionMode */25,
          _0: response
        };
}

var MRTransform_AskTabToExitDataExtractionMode = {
  message_encode: message_encode$52,
  message_decode: message_decode$52,
  response_encode: response_encode$52,
  response_decode: response_decode$52,
  allMessage_encode: allMessage_encode$25,
  allMessage_decode: allMessage_decode$25,
  allResponse_encode: allResponse_encode$25,
  allResponse_decode: allResponse_decode$25,
  responseError_encode: responseError_encode$25,
  responseError_decode: responseError_decode$25,
  wrapMessageAsAllMessage: wrapMessageAsAllMessage$25,
  unwrapAllResponseAsResponse: unwrapAllResponseAsResponse$25,
  wrapResponseAsAllResponse: wrapResponseAsAllResponse$25
};

var AskTabToExitDataExtractionMode = ExtensionMessagingBuilders$SmartcutsMacros.MakeExtensionMessageSender(MRTransform_AskTabToExitDataExtractionMode);

var message_encode$53 = message_encode$26;

var message_decode$53 = message_decode$26;

var response_encode$53 = response_encode$26;

var response_decode$53 = response_decode$26;

function responseError_encode$26(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_encode(v);
}

function responseError_decode$26(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptResponseError.t_decode(v);
}

function result_encode(v) {
  return Decco.resultToJson(response_encode$53, responseError_encode$26, v);
}

function result_decode(v) {
  return Decco.resultFromJson(response_decode$53, responseError_decode$26, v);
}

function respondToSender_encode(_fn) {
  return "respondToSender";
}

function respondToSender_decode(encoded) {
  var str = Js_json.decodeString(encoded);
  if (str !== undefined) {
    if (str === "respondToSender") {
      return {
              TAG: /* Ok */0,
              _0: (function (_result) {
                  
                })
            };
    } else {
      return Decco.error(undefined, "Expected 'respondToSender' json string, but got " + StringUtils$SmartcutsMacros.quote(str), encoded);
    }
  } else {
    return Decco.error(undefined, "Couldn't decode json into respondToSender", encoded);
  }
}

function onMessageFromExtension(listener) {
  return Browser__Runtime$SmartcutsMacros.OnMessageFromExtension.addListener(function (json) {
              return Curry._1(listener, Belt_Result.getExn(message_decode$26(json))).then(function (result) {
                          return Promise.resolve(Decco.resultToJson(response_encode$53, responseError_encode$26, result));
                        });
            });
}

var All = {
  message_encode: message_encode$53,
  message_decode: message_decode$53,
  response_encode: response_encode$53,
  response_decode: response_decode$53,
  responseError_encode: responseError_encode$26,
  responseError_decode: responseError_decode$26,
  result_encode: result_encode,
  result_decode: result_decode,
  respondToSender_encode: respondToSender_encode,
  respondToSender_decode: respondToSender_decode,
  onMessageFromExtension: onMessageFromExtension
};

exports.MR_StartStreamingEventsToBackground = MR_StartStreamingEventsToBackground;
exports.MR_StopStreamingEventsToBackground = MR_StopStreamingEventsToBackground;
exports.MR_Playback = MR_Playback;
exports.MR_PlaybackExited = MR_PlaybackExited;
exports.MR_RenderInContentScript = MR_RenderInContentScript;
exports.MR_AskContentScriptToAdjustModalGeometry = MR_AskContentScriptToAdjustModalGeometry;
exports.MR_AskContentScriptToEnterUrlTriggeringMode = MR_AskContentScriptToEnterUrlTriggeringMode;
exports.MR_UrlTriggering_RefreshLinks = MR_UrlTriggering_RefreshLinks;
exports.MR_UrlTriggering_UpdateLinks = MR_UrlTriggering_UpdateLinks;
exports.MR_UrlTriggering_TellTabToUpdateLinkGroups = MR_UrlTriggering_TellTabToUpdateLinkGroups;
exports.MR_UrlTriggering_Exit = MR_UrlTriggering_Exit;
exports.MR_UrlTriggering_AskContentScriptToRecordPageAction = MR_UrlTriggering_AskContentScriptToRecordPageAction;
exports.MR_UrlTriggering_StopRecordPageAction = MR_UrlTriggering_StopRecordPageAction;
exports.MR_UrlTriggering_PlaybackPageAction = MR_UrlTriggering_PlaybackPageAction;
exports.MR_UrlTriggering_DidFinishPlaybackPageAction = MR_UrlTriggering_DidFinishPlaybackPageAction;
exports.MR_UrlTriggering_ShowLinkWithId = MR_UrlTriggering_ShowLinkWithId;
exports.MR_UrlTriggering_SendContextLocalAndLinkGroups = MR_UrlTriggering_SendContextLocalAndLinkGroups;
exports.MR_UrlTriggering_PrepareForScreenshot = MR_UrlTriggering_PrepareForScreenshot;
exports.MR_PingTab = MR_PingTab;
exports.MR_DoesElementExistOnPage = MR_DoesElementExistOnPage;
exports.MR_AskTabToRenderModalToExplainHighlightElement = MR_AskTabToRenderModalToExplainHighlightElement;
exports.MR_AskTabToSetupHighlightElementControl = MR_AskTabToSetupHighlightElementControl;
exports.MR_AskTabToTeardownHighlightElementControl = MR_AskTabToTeardownHighlightElementControl;
exports.MR_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = MR_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand;
exports.MR_AskTabToEnterDataExtractionMode = MR_AskTabToEnterDataExtractionMode;
exports.MR_AskTabToExitDataExtractionMode = MR_AskTabToExitDataExtractionMode;
exports.MR_All = MR_All;
exports.MRTransform_StartStreamingEventsToBackground = MRTransform_StartStreamingEventsToBackground;
exports.StartStreamingEventsToBackground = StartStreamingEventsToBackground;
exports.MRTransform_StopStreamingEventsToBackground = MRTransform_StopStreamingEventsToBackground;
exports.StopStreamingEventsToBackground = StopStreamingEventsToBackground;
exports.MRTransform_Playback = MRTransform_Playback;
exports.Playback = Playback;
exports.MRTransform_PlaybackExited = MRTransform_PlaybackExited;
exports.PlaybackExited = PlaybackExited;
exports.MRTransform_RenderInContentScript = MRTransform_RenderInContentScript;
exports.RenderInContentScript = RenderInContentScript;
exports.MRTransform_AskContentScriptToAdjustModalGeometry = MRTransform_AskContentScriptToAdjustModalGeometry;
exports.AskContentScriptToAdjustModalGeometry = AskContentScriptToAdjustModalGeometry;
exports.MRTransform_AskContentScriptToEnterUrlTriggeringMode = MRTransform_AskContentScriptToEnterUrlTriggeringMode;
exports.AskContentScriptToEnterUrlTriggeringMode = AskContentScriptToEnterUrlTriggeringMode;
exports.MRTransform_UrlTriggering_RefreshLinks = MRTransform_UrlTriggering_RefreshLinks;
exports.UrlTriggering_RefreshLinks = UrlTriggering_RefreshLinks;
exports.MRTransform_UrlTriggering_UpdateLinks = MRTransform_UrlTriggering_UpdateLinks;
exports.UrlTriggering_UpdateLinks = UrlTriggering_UpdateLinks;
exports.MRTransform_UrlTriggering_TellTabToUpdateLinkGroups = MRTransform_UrlTriggering_TellTabToUpdateLinkGroups;
exports.UrlTriggering_TellTabToUpdateLinkGroups = UrlTriggering_TellTabToUpdateLinkGroups;
exports.MRTransform_UrlTriggering_Exit = MRTransform_UrlTriggering_Exit;
exports.UrlTriggering_Exit = UrlTriggering_Exit;
exports.MRTransform_UrlTriggering_AskContentScriptToRecordPageAction = MRTransform_UrlTriggering_AskContentScriptToRecordPageAction;
exports.UrlTriggering_AskContentScriptToRecordPageAction = UrlTriggering_AskContentScriptToRecordPageAction;
exports.MRTransform_UrlTriggering_StopRecordPageAction = MRTransform_UrlTriggering_StopRecordPageAction;
exports.UrlTriggering_StopRecordPageAction = UrlTriggering_StopRecordPageAction;
exports.MRTransform_UrlTriggering_PlaybackPageAction = MRTransform_UrlTriggering_PlaybackPageAction;
exports.UrlTriggering_PlaybackPageAction = UrlTriggering_PlaybackPageAction;
exports.MRTransform_UrlTriggering_DidFinishPlaybackPageAction = MRTransform_UrlTriggering_DidFinishPlaybackPageAction;
exports.UrlTriggering_DidFinishPlaybackPageAction = UrlTriggering_DidFinishPlaybackPageAction;
exports.MRTransform_UrlTriggering_ShowLinkWithId = MRTransform_UrlTriggering_ShowLinkWithId;
exports.UrlTriggering_ShowLinkWithId = UrlTriggering_ShowLinkWithId;
exports.MRTransform_UrlTriggering_SendContextLocalAndLinkGroups = MRTransform_UrlTriggering_SendContextLocalAndLinkGroups;
exports.UrlTriggering_SendContextLocalAndLinkGroups = UrlTriggering_SendContextLocalAndLinkGroups;
exports.MRTransform_UrlTriggering_PrepareForScreenshot = MRTransform_UrlTriggering_PrepareForScreenshot;
exports.UrlTriggering_PrepareForScreenshot = UrlTriggering_PrepareForScreenshot;
exports.MRTransform_PingTab = MRTransform_PingTab;
exports.PingTab = PingTab;
exports.MRTransform_DoesElementExistOnPage = MRTransform_DoesElementExistOnPage;
exports.DoesElementExistOnPage = DoesElementExistOnPage;
exports.MRTransform_AskTabToRenderModalToExplainHighlightElement = MRTransform_AskTabToRenderModalToExplainHighlightElement;
exports.AskTabToRenderModalToExplainHighlightElement = AskTabToRenderModalToExplainHighlightElement;
exports.MRTransform_AskTabToSetupHighlightElementControl = MRTransform_AskTabToSetupHighlightElementControl;
exports.AskTabToSetupHighlightElementControl = AskTabToSetupHighlightElementControl;
exports.MRTransform_AskTabToTeardownHighlightElementControl = MRTransform_AskTabToTeardownHighlightElementControl;
exports.AskTabToTeardownHighlightElementControl = AskTabToTeardownHighlightElementControl;
exports.MRTransform_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = MRTransform_AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand;
exports.AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand = AskTabToHideSmartcutsPlaybackModalUntilCompletedCommand;
exports.MRTransform_AskTabToEnterDataExtractionMode = MRTransform_AskTabToEnterDataExtractionMode;
exports.AskTabToEnterDataExtractionMode = AskTabToEnterDataExtractionMode;
exports.MRTransform_AskTabToExitDataExtractionMode = MRTransform_AskTabToExitDataExtractionMode;
exports.AskTabToExitDataExtractionMode = AskTabToExitDataExtractionMode;
exports.All = All;
/* StartStreamingEventsToBackground Not a pure module */
